// Phase-1 i18n dictionary — app "chrome" (nav, launcher, login, account, buttons).
// Page/module content is added incrementally. Keys fall back to Japanese, then the key.
export const TRANSLATIONS = {
  // ── common / buttons ──
  'common.home': { ja: 'ホーム', en: 'Home' },
  'common.settings': { ja: '設定', en: 'Settings' },
  'common.logout': { ja: 'ログアウト', en: 'Log out' },
  'common.installApp': { ja: 'アプリをインストール', en: 'Install app' },
  'common.open': { ja: '開く', en: 'Open' },
  'common.close': { ja: '閉じる', en: 'Close' },
  'common.dropFile': { ja: 'ファイルをここにドロップ、またはクリックして選択', en: 'Drop a file here, or click to choose' },
  'common.clearFile': { ja: '選択を解除', en: 'Remove file' },
  'common.fileRequired': { ja: 'ファイルを選択してください', en: 'Please choose a file' },
  'common.save': { ja: '保存', en: 'Save' },
  'common.saving': { ja: '保存中…', en: 'Saving…' },
  'common.cancel': { ja: 'キャンセル', en: 'Cancel' },
  'common.loading': { ja: '読み込み中…', en: 'Loading…' },
  'cap.settings': { ja: '設定へのアクセス', en: 'Access to settings' },
  'cap.users': { ja: 'ユーザー管理', en: 'User management' },
  'cap.employees': { ja: '社員管理', en: 'Employee management' },
  'cap.departments': { ja: '部署管理', en: 'Department management' },
  'cap.email': { ja: 'メール設定', en: 'Email settings' },
  'cap.audit_log': { ja: '監査ログ閲覧', en: 'View audit log' },
  'cap.all_submissions': { ja: '全申請の閲覧', en: 'View all submissions' },
  'cap.verify': { ja: '承認・検証', en: 'Approve & verify' },
  'cap.mfg_operate': { ja: '製造オペレーション', en: 'Manufacturing operations' },
  'cap.mfg_dept_scope': { ja: '製造部スコープ（自部門のみ・設定/IT非表示）', en: 'Production scope (own department only, no Settings/IT)' },
  'cap.approve': { ja: '承認者としての承認', en: 'Approve as approver' },
  'cap.chat_manage': { ja: 'チャンネル管理', en: 'Manage chat channels' },
  'cap.it_edit': { ja: 'IT編集', en: 'Edit IT assets' },
  'cap.mfg_edit': { ja: '製造編集', en: 'Edit manufacturing data' },
  'cap.shizai_edit': { ja: '資材編集', en: 'Edit procurement data' },
  'cap.shizai_request': { ja: '部品受注入力の送信', en: 'Submit parts requests' },
  'cap.planner_manage': { ja: 'プロジェクト管理', en: 'Manage projects' },
  'cap.knowledge_edit': { ja: 'ナレッジ編集', en: 'Edit knowledge pages' },
  'cap.mfg_wo_release': { ja: '製造オーダー開始', en: 'Release work orders' },
  'cap.lookups_edit': { ja: '共通マスターへの追加', en: 'Add to shared masters' },
  'cap.label_manage': { ja: 'ラベルテンプレート管理', en: 'Manage label templates' },
  'cap.app_kintai': { ja: 'アプリ: 勤怠申請', en: 'App: HR forms' },
  'cap.app_chat': { ja: 'アプリ: チャット', en: 'App: Chat' },
  'cap.app_it': { ja: 'アプリ: IT資産', en: 'App: IT assets' },
  'cap.app_mfg': { ja: 'アプリ: 製造管理', en: 'App: Manufacturing' },
  'cap.app_shizai': { ja: 'アプリ: 資材', en: 'App: Procurement' },
  'cap.app_parts_request': { ja: 'アプリ: 部品受注入力', en: 'App: Parts request' },
  'cap.app_planner': { ja: 'アプリ: プロジェクト', en: 'App: Planner' },
  'cap.app_knowledge': { ja: 'アプリ: ナレッジ', en: 'App: Knowledge' },
  'cap.app_scanner': { ja: 'アプリ: スキャナー', en: 'App: Scanner' },
  'cap.app_engineering': { ja: 'アプリ: 技術', en: 'App: Engineering' },
  'cap.app_bihin': { ja: 'アプリ: 備品管理', en: 'App: Office Equipment' },
  'cap.bihin_edit': { ja: '備品管理: 編集', en: 'Office equipment: edit' },
  'cap.app_settings': { ja: 'アプリ: 設定', en: 'App: Settings' },
  'users.title': { ja: 'ユーザー管理', en: 'User management' },
  'users.subtitle': { ja: 'アプリにログインできるユーザーとアクセス権限 (admin / 管理者 / ユーザー) を管理します。', en: 'Manage the users who can sign in and their access levels (admin / manager / user).' },
  'users.printCreds': { ja: '認証情報を印刷', en: 'Print credentials' },
  'users.bulkAdd': { ja: '一括登録', en: 'Bulk add' },
  'users.addUser': { ja: 'ユーザーを追加', en: 'Add user' },
  'users.editUser': { ja: 'ユーザーを編集', en: 'Edit user' },
  'users.stat.total': { ja: '合計', en: 'Total' },
  'users.role.admin': { ja: 'admin', en: 'Admin' },
  'users.role.manager': { ja: '管理者', en: 'Manager' },
  'users.role.user': { ja: 'ユーザー', en: 'User' },
  'users.role.adminDesc': { ja: 'すべての機能と設定にアクセス可能', en: 'Full access to every feature and setting' },
  'users.role.managerDesc': { ja: '社員・部署と全申請履歴の管理が可能', en: 'Can manage employees, departments and all submissions' },
  'users.role.userDesc': { ja: '申請フォームと自分の申請履歴のみ閲覧', en: 'Can submit forms and view only their own submissions' },
  'users.searchPh': { ja: '氏名・メールアドレスで検索', en: 'Search by name or email' },
  'users.filterRolePh': { ja: '権限で絞り込み', en: 'Filter by role' },
  'users.filter.all': { ja: 'すべての権限', en: 'All roles' },
  'users.emptyFiltered': { ja: '条件に合うユーザーが見つかりません。', en: 'No users match your filters.' },
  'users.empty': { ja: 'ユーザーがいません。', en: 'No users yet.' },
  'users.self': { ja: '自分', en: 'You' },
  'users.active': { ja: '有効', en: 'Active' },
  'users.inactive': { ja: '無効', en: 'Inactive' },
  'users.linkedEmployee': { ja: '紐付け社員', en: 'Linked employee' },
  'users.createdAt': { ja: '作成日', en: 'Created' },
  'users.reset': { ja: 'リセット', en: 'Reset' },
  'users.edit': { ja: '編集', en: 'Edit' },
  'users.th.user': { ja: 'ユーザー', en: 'User' },
  'users.th.role': { ja: '権限', en: 'Role' },
  'users.th.status': { ja: '状態', en: 'Status' },
  'users.th.actions': { ja: '操作', en: 'Actions' },
  'users.selfStateLock': { ja: '自分自身の状態は変更できません', en: 'You cannot change your own status' },
  'users.deactivate': { ja: '無効にする', en: 'Deactivate' },
  'users.activate': { ja: '有効にする', en: 'Activate' },
  'users.resetPwTitle': { ja: 'パスワードをリセット', en: 'Reset password' },
  'users.menu.edit': { ja: '編集', en: 'Edit' },
  'users.menu.delete': { ja: '削除', en: 'Delete' },
  'users.resetPwDesc': { ja: '「{name}」の新しいパスワードを入力してください。', en: 'Enter a new password for "{name}".' },
  'users.resetPwPh': { ja: '新しいパスワード (8文字以上)', en: 'New password (min 8 characters)' },
  'users.resetPwNote': { ja: '新しいパスワードを本人にお伝えください。ログイン後にユーザー自身で変更することを推奨します。', en: 'Share the new password with the user. We recommend they change it after signing in.' },
  'users.f.name': { ja: '氏名', en: 'Name' },
  'users.f.namePh': { ja: '例: 山田 太郎', en: 'e.g. Taro Yamada' },
  'users.f.email': { ja: 'メールアドレス', en: 'Email address' },
  'users.emailLock': { ja: 'メールアドレスは作成後に変更できません。', en: 'Email cannot be changed after creation.' },
  'users.f.password': { ja: 'パスワード', en: 'Password' },
  'users.f.pwMin': { ja: '(8文字以上)', en: '(min 8 characters)' },
  'users.f.newPw': { ja: '新しいパスワード (任意・8文字以上)', en: 'New password (optional, min 8 characters)' },
  'users.f.pwKeepPh': { ja: '変更しない場合は空欄', en: 'Leave blank to keep current' },
  'users.f.role': { ja: '権限', en: 'Role' },
  'users.f.employee': { ja: '紐付け社員 (任意)', en: 'Linked employee (optional)' },
  'users.f.employeePh': { ja: '社員を選択', en: 'Select an employee' },
  'users.f.noLink': { ja: '紐付けなし', en: 'Not linked' },
  'users.f.mfgDept': { ja: '所属製造部門', en: 'Production department' },
  'users.f.mfgDeptHint': {
    ja: '「製造部スコープ」が有効なユーザーは、この部門のデータだけが見えます（空欄なら社員の所属部署名から自動判定）。',
    en: 'Users with Production scope only see this department (left blank, it is matched from the linked employee\u2019s department name).',
  },
  'users.linkHint': { ja: '紐付けると、申請履歴の「自分の申請」フィルタが正しく動作します。', en: 'Linking makes the "My submissions" filter work correctly.' },
  'users.capTitle': { ja: '権限の個別設定', en: 'Per-user capability overrides' },
  'users.capHint': { ja: 'ロール ({role}) の既定を上書きします。「継承」はロール設定に従います。', en: 'Overrides the defaults of the {role} role. "Inherit" follows the role settings.' },
  'users.capHintAdmin': { ja: '管理者は既定で全機能が有効です。「拒否」にした機能だけ制限されます（全権限の管理者が最低1名必要）。', en: 'Admins have every function ON by default. Only functions set to "Deny" are restricted (at least one full admin must remain).' },
  'users.cap.inherit': { ja: '継承 ({state})', en: 'Inherit ({state})' },
  'users.cap.allow': { ja: '許可', en: 'Allow' },
  'users.cap.deny': { ja: '禁止', en: 'Deny' },
  'users.activeToggle': { ja: 'アカウントを有効にする', en: 'Account enabled' },
  'users.activeToggleHint': { ja: '無効にするとログインできなくなります。', en: 'Disabled accounts cannot sign in.' },
  'users.t.loadFail': { ja: '読み込みに失敗しました', en: 'Failed to load' },
  'users.t.nameReq': { ja: '氏名を入力してください', en: 'Please enter a name' },
  'users.t.emailReq': { ja: 'メールアドレスを入力してください', en: 'Please enter an email address' },
  'users.t.pwMin': { ja: 'パスワードは8文字以上で入力してください', en: 'Password must be at least 8 characters' },
  'users.t.added': { ja: 'ユーザーを追加しました', en: 'User added' },
  'users.t.updated': { ja: 'ユーザーを更新しました', en: 'User updated' },
  'users.t.saveFail': { ja: '保存に失敗しました', en: 'Failed to save' },
  'users.t.delSelf': { ja: '自分自身を削除することはできません', en: 'You cannot delete yourself' },
  'users.t.delConfirm': { ja: '「{name}」を削除しますか？この操作は取り消せません。', en: 'Delete "{name}"? This cannot be undone.' },
  'users.t.deleted': { ja: '削除しました', en: 'Deleted' },
  'users.t.delFail': { ja: '削除に失敗しました', en: 'Failed to delete' },
  'users.t.deactivated': { ja: '無効にしました', en: 'Deactivated' },
  'users.t.activated': { ja: '有効にしました', en: 'Activated' },
  'users.t.updateFail': { ja: '更新に失敗しました', en: 'Failed to update' },
  'users.t.pwResetDone': { ja: '「{name}」のパスワードをリセットしました', en: 'Password for "{name}" has been reset' },
  'users.t.resetFail': { ja: 'リセットに失敗しました', en: 'Failed to reset' },
  'common.comingSoon': { ja: '近日公開', en: 'Coming soon' },

  // ── language toggle ──
  'lang.ja': { ja: '日本語', en: '日本語' },
  'lang.en': { ja: 'EN', en: 'EN' },

  // ── login ──
  'login.subtitle': { ja: 'ログインして続行', en: 'Sign in to continue' },
  'login.email': { ja: 'メールアドレス', en: 'Email address' },
  'login.password': { ja: 'パスワード', en: 'Password' },
  'login.submit': { ja: 'ログイン', en: 'Sign in' },
  'login.submitting': { ja: 'ログイン中…', en: 'Signing in…' },
  'login.showPw': { ja: 'パスワードを表示', en: 'Show password' },
  'login.hidePw': { ja: 'パスワードを隠す', en: 'Hide password' },
  'login.forgot': { ja: 'パスワードをお忘れの場合は管理者にお問い合わせください。', en: 'Forgot your password? Please contact your administrator.' },
  'login.success': { ja: 'ログインしました', en: 'Signed in' },
  'login.failed': { ja: 'ログインに失敗しました', en: 'Sign-in failed' },

  // ── header / nav ──
  'nav.forms': { ja: '申請フォーム', en: 'Forms' },
  'nav.history': { ja: '申請履歴', en: 'History' },
  'nav.chat': { ja: 'チャット', en: 'Chat' },
  'tab.kintai': { ja: '勤怠', en: 'Work' },
  'tab.it': { ja: 'IT', en: 'IT' },
  'tab.mfg': { ja: '製造', en: 'Mfg' },
  'tab.shizai': { ja: '資材', en: 'Material' },
  'tab.planner': { ja: 'PJ', en: 'Plan' },
  'tab.chat': { ja: 'チャット', en: 'Chat' },
  'nav.it': { ja: 'ITシステム管理', en: 'IT System' },
  'nav.unverified': { ja: '未承認 {n}件', en: '{n} unverified' },
  'nav.menu': { ja: 'メインメニュー', en: 'Main menu' },
  'nav.apps': { ja: 'アプリ', en: 'Apps' },
  'nav.openMenu': { ja: 'メニューを開く', en: 'Open menu' },
  'logout.success': { ja: 'ログアウトしました', en: 'Signed out' },

  // ── app chip / launcher app names ──
  'app.kintai': { ja: '勤怠管理', en: 'Attendance' },
  'app.chat': { ja: 'チャット', en: 'Chat' },
  'app.it': { ja: 'ITシステム管理', en: 'IT System' },
  'app.settings': { ja: '設定', en: 'Settings' },
  'app.knowledge': { ja: 'ナレッジ', en: 'Knowledge' },
  'app.docs': { ja: 'ドキュメント', en: 'Documents' },

  // ── launcher ──
  'launcher.subtitle': { ja: 'アプリを選択して開始してください', en: 'Select an app to get started' },
  'launcher.section.assets': { ja: '資産管理', en: 'Asset Management' },
  'launcher.desc.assets_group': { ja: 'ITシステム管理・備品管理', en: 'IT systems & office equipment' },
  'app.myit': { ja: 'マイデバイス', en: 'My Devices' },
  'launcher.desc.myit': { ja: '自分に割り当てられたPC・ライセンス・メールを確認', en: 'View your assigned devices, licenses & email accounts' },
  'launcher.desc.kintai': { ja: '残業・休暇・勤務時間・出張の各種申請', en: 'Overtime, leave, work hours & business-trip requests' },
  'launcher.desc.engineering': { ja: '技術資産・設備・データ収集の管理', en: 'Engineering assets, equipment & data collection' },
  'launcher.desc.chat': { ja: 'チームでリアルタイムに会話・相談', en: 'Real-time team chat & discussion' },
  'launcher.desc.it': { ja: 'VLAN・IP管理、備品・ライセンス・申請', en: 'VLAN/IP, assets, licenses & requests' },
  'launcher.desc.settings': { ja: '署名・部署・各種設定', en: 'Signature, departments & settings' },
  'launcher.desc.knowledge': { ja: '手順書・マニュアル・議事録などの社内ナレッジ', en: 'Internal docs, manuals & meeting notes' },

  // ── account menu ──
  'account.installedAddedToast': { ja: 'ホーム画面にショートカットを追加しました', en: 'Added a shortcut to your home screen' },
  'account.installIosHint': { ja: 'Safari の共有ボタン → 「ホーム画面に追加」でショートカットを作成できます', en: 'In Safari: Share → "Add to Home Screen" to create a shortcut' },

  // ── roles ──
  'role.admin': { ja: 'admin', en: 'Admin' },
  'role.manager': { ja: '管理者', en: 'Manager' },
  'role.user': { ja: 'ユーザー', en: 'User' },

  // ── settings submenu (mobile) ──
  'settings.section': { ja: '設定', en: 'Settings' },
  'settings.employees': { ja: '社員管理', en: 'Employees' },
  'settings.users': { ja: 'ユーザー管理', en: 'Users' },
  'settings.roles': { ja: 'ロール権限', en: 'Roles & Permissions' },
  'settings.engMembers': { ja: '技術メンバー', en: 'Engineering Members' },
  'settings.itMembers': { ja: 'ITメンバー', en: 'IT Members' },
  'settings.itCategories': { ja: 'IT資産マスタ', en: 'IT Asset Master' },
  'settings.engShelves': { ja: '棚マスタ（技術）', en: 'Shelf Master (Engineering)' },
  'settings.modules': { ja: 'モジュール設定', en: 'Module Settings' },
  'settings.departments': { ja: '部署管理', en: 'Departments' },
  'settings.signature': { ja: '署名・捺印', en: 'Signature & Seal' },
  // Batch 8 · iter_161
  'settings.aiPreferences': { ja: 'AIアシスタント', en: 'AI Assistant' },
  'settings.aiConsole': { ja: 'AI管理コンソール', en: 'AI Management Console' },
  'settings.aiImportHistory': { ja: 'AIインポート履歴', en: 'AI Import History' },
  'settings.aiLearning': { ja: 'AI学習ソース', en: 'AI Learning Sources' },
  'settings.aiSearchStatus': { ja: 'AIが検索できる情報', en: 'AI Searchable Information' },
  'settings.aiCode': { ja: 'コードインタープリタ', en: 'Code Interpreter' },
  'settings.auditLog': { ja: '監査ログ', en: 'Audit Log' },
  'settings.email': { ja: 'メール (SMTP) 設定', en: 'Email (SMTP)' },
  'settings.emailTemplates': { ja: 'メールテンプレート', en: 'Email Templates' },
  'settings.emailLog': { ja: 'メール送信履歴', en: 'Email Log' },
  'settings.workflow': { ja: '承認ワークフロー', en: 'Approval Workflow' },
  'settings.backup': { ja: 'バックアップ', en: 'Backup' },
  'settings.storage': { ja: 'ファイルストレージ', en: 'File Storage' },
  'settings.labels': { ja: 'ラベルデザイナー', en: 'Label Designer' },
  'settings.orderCategories': { ja: '受注分類', en: 'Order Categories' },
  'settings.deliveryDest': { ja: '納入先', en: 'Delivery Destinations' },
  'settings.lookups': { ja: '共通マスター', en: 'Master Lookups' },
  'settings.shizaiNotifications': { ja: '資材 通知設定', en: 'Shizai Notifications' },
  'settings.adminNotify': { ja: '管理者通知設定', en: 'Admin Notifications' },
  'settings.holidays': { ja: '祝日・休業日', en: 'Holidays' },
  'settings.dataPrep': { ja: 'データ管理（準備用）', en: 'Data Prep (temp)' },
  'settings.changelog': { ja: '更新履歴', en: 'Changelog' },
  'settings.traceability': { ja: '横断トレーサビリティ', en: 'Traceability' },
  'settings.demo': { ja: 'デモモード', en: 'Demo Mode' },
  'settings.skuMaster': { ja: '品番マスター', en: 'SKU Master' },
  'settings.skuMasterHint': { ja: '大分類・中分類・ユニット図番・カウンター管理', en: '大分類 / 中分類 / Unit codes / Counters' },
  // iter_143f · Master data consolidated hub (moved from /mfg/master)
  'settings.mfgMaster': { ja: '生産マスター', en: 'Production Masters' },
  'settings.mfgMasterHint': { ja: '仕入先・場所・作業拠点・カテゴリ・単位・メーカー', en: 'Suppliers / Locations / WorkCenters / Categories / UoMs / Makers' },
  'settings.skuTemplates': { ja: '品番テンプレート', en: 'SKU Templates' },
  'settings.shizaiApprovals': { ja: '発注承認ルール', en: 'PO Approval Rules' },
  'settings.shizaiDelegations': { ja: '承認委任', en: 'Approval Delegation' },
  'settings.mail': { ja: 'メール', en: 'Email' },
  'settings.menu': { ja: 'メニュー', en: 'Menu' },
  'settings.menuOpen': { ja: '設定メニューを開く', en: 'Open settings menu' },
  'settings.menuTitle': { ja: '設定メニュー', en: 'Settings menu' },
  // Sidebar group labels
  'settings.group.org':      { ja: '組織',       en: 'Organization' },
  'settings.group.workflow': { ja: 'ワークフロー', en: 'Workflow' },
  'settings.group.master':   { ja: 'マスター',     en: 'Master Data' },
  'settings.group.notify':   { ja: '通知',       en: 'Notifications' },
  'settings.group.system':   { ja: 'システム',   en: 'System' },
  'account.changePassword': { ja: 'パスワードを変更', en: 'Change password' },

  // ── app chip / launcher: 製造管理 (manufacturing) ──
  'app.mfg': { ja: '製造管理', en: 'Manufacturing' },
  'nav.mfg': { ja: '製造管理', en: 'Manufacturing' },
  'launcher.desc.mfg': { ja: '在庫・ロット・倉庫・バーコード管理', en: 'Inventory, lots, warehouse & barcodes' },
  'app.planner': { ja: 'プロジェクト', en: 'Projects' },
  'app.engineering': { ja: '技術', en: 'Engineering' },
  'app.bihin': { ja: '備品管理', en: 'Office Equipment' },
  'nav.planner': { ja: 'プロジェクト', en: 'Projects' },
  'nav.engineering': { ja: '技術', en: 'Engineering' },
  'nav.bihin': { ja: '備品管理', en: 'Office Equipment' },
  'launcher.desc.bihin': { ja: 'オフィス備品・消耗品・貸出・フロアマップ', en: 'Office equipment, consumables, loans & floormap' },
  'launcher.desc.planner': { ja: '部署別のプロジェクト・タスク・ガント', en: 'Dept projects, tasks & Gantt' },
  'app.docs': { ja: 'ドキュメント', en: 'Documents' },
  'launcher.desc.docs': { ja: '文書管理 — 図面・マニュアル・記録の保管と版管理', en: 'Documents — drawings, manuals, records with version control' },

  // ── プロジェクト管理 (Project Planner) ──
  'planner.subtitle': { ja: '部署別プロジェクト', en: 'Department projects' },
  'planner.home.subtitle': { ja: '部署を選んでプロジェクトを管理しましょう。', en: 'Pick a department to manage its projects.' },
  'planner.home.projects': { ja: '{n} 件のプロジェクト', en: '{n} projects' },
  'planner.home.active': { ja: '進行中 {n}', en: '{n} active' },
  'planner.nav.home': { ja: 'ホーム', en: 'Home' },
  'planner.nav.myTasks': { ja: 'マイタスク', en: 'My tasks' },
  'planner.nav.myProjects': { ja: 'マイプロジェクト', en: 'My projects' },
  'planner.nav.departments': { ja: '部署', en: 'Departments' },
  'planner.myTasks.title': { ja: 'マイタスク', en: 'My tasks' },
  'planner.myTasks.subtitle': { ja: 'あなたが参加しているすべてのタスク', en: 'Every task you are a member of' },
  'planner.myTasks.empty': { ja: '参加しているタスクはありません。', en: 'You have no tasks.' },
  'planner.myTasks.notLinked': { ja: 'あなたのアカウントは社員情報と紐付いていません。管理者に連絡してください。', en: 'Your account is not linked to an employee record. Please contact an admin.' },
  'planner.myTasks.showDone': { ja: '完了も表示', en: 'Show done' },
  'planner.myTasks.project': { ja: 'プロジェクト', en: 'Project' },

  // Batch 3 · iter_153 · My Projects — participation rule (Q1=c): owner OR project-member OR any-task-member.
  'planner.myProjects.title': { ja: 'マイプロジェクト', en: 'My projects' },
  'planner.myProjects.subtitle': { ja: 'あなたが参加しているすべてのプロジェクト', en: 'Every project you are a member of' },
  'planner.myProjects.empty': { ja: '参加しているプロジェクトはありません。', en: 'You have no projects yet.' },
  'planner.myProjects.emptyHint': { ja: '「新規プロジェクト」をクリックして最初のプロジェクトを作成しましょう。', en: 'Click "New project" to create your first one.' },
  'planner.myProjects.notLinked': { ja: 'あなたのアカウントは社員情報と紐付いていません。管理者に連絡してください。', en: 'Your account is not linked to an employee record. Please contact an admin.' },
  'planner.myProjects.showArchived': { ja: '完了も表示', en: 'Show completed' },
  'planner.myProjects.searchPh': { ja: 'プロジェクト名で検索…', en: 'Search project name…' },
  'planner.myProjects.filterAll': { ja: 'すべて', en: 'All' },
  'planner.myProjects.role.owner': { ja: 'オーナー', en: 'Owner' },
  'planner.myProjects.role.member': { ja: 'メンバー', en: 'Member' },
  'planner.myProjects.role.task_member': { ja: 'タスク担当', en: 'Task member' },
  'planner.myProjects.deptRequired': { ja: '部署を選択してください', en: 'Please choose a department' },
  'planner.myProjects.deptLabel': { ja: '部署', en: 'Department' },
  'planner.myProjects.deptPh': { ja: '部署を選択...', en: 'Choose a department…' },
  'planner.filter.mine': { ja: '自分が参加', en: 'My tasks' },
  'planner.alerts.bell': { ja: 'プロジェクト通知', en: 'Project alerts' },
  'planner.dept.title': { ja: 'プロジェクト概要', en: 'Project overview' },
  'planner.dept.gantt': { ja: '部署全体のガントチャート', en: 'Department Gantt' },
  'planner.dept.ganttEmpty': { ja: '期間が設定されたプロジェクトがありません。', en: 'No projects with dates yet.' },
  'planner.dept.archivedTitle': { ja: '完了済みプロジェクト', en: 'Completed projects' },
  'planner.dept.archivedHelp': { ja: '完了にしたプロジェクト（期限とは無関係）', en: 'Projects marked finished (independent of due date)' },
  'planner.dept.overdueMark': { ja: '期限超過', en: 'Past due' },
  'planner.dept.archivedEmpty': { ja: '完了済みプロジェクトはありません。', en: 'No completed projects.' },
  'planner.dept.projects': { ja: 'プロジェクト一覧', en: 'Projects' },
  'planner.dept.showArchivedCards': { ja: '完了も表示', en: 'Show completed' },
  'planner.dept.noProjects': { ja: 'まだプロジェクトがありません。', en: 'No projects yet.' },
  'planner.dept.open': { ja: '開く', en: 'Open' },
  'planner.stat.activeProjects': { ja: '進行中の案件', en: 'Active projects' },
  'planner.stat.totalTasks': { ja: 'タスク合計', en: 'Total tasks' },
  'planner.stat.dueSoon': { ja: '期限間近', en: 'Due soon' },
  'planner.stat.overdue': { ja: '期限超過', en: 'Overdue' },
  'planner.stat.blocked': { ja: 'ブロック中', en: 'Blocked' },
  'planner.alerts.overdue': { ja: '期限超過のタスク', en: 'Overdue tasks' },
  'planner.alerts.dueSoon': { ja: '期限間近のタスク', en: 'Due-soon tasks' },
  'planner.alerts.mine': { ja: '自分の期限超過タスク', en: 'My overdue tasks' },
  'planner.alerts.seeAll': { ja: 'すべて見る', en: 'See all' },
  'planner.alerts.mineOpen': { ja: '自分の未完了タスク', en: 'My open tasks' },
  'planner.alerts.blockedNote': { ja: 'うちブロック中 {n} 件', en: '{n} blocked' },
  'planner.count': { ja: '{n} 件', en: '{n} items' },
  'planner.share': { ja: '共有', en: 'Share' },
  'planner.printPdf': { ja: '印刷 / PDF', en: 'Print / PDF' },
  'planner.metrics': { ja: '参考指標', en: 'Reference metrics' },
  'planner.popupBlocked': { ja: 'ポップアップがブロックされました。ブラウザでポップアップを許可してください。', en: 'The popup was blocked. Please allow popups for this site.' },
  'planner.nav.digest': { ja: '週間ダイジェスト', en: 'Weekly digest' },
  'planner.zone.action': { ja: '対応が必要', en: 'Needs attention' },
  'planner.zone.actionHint': { ja: '期限とブロッカーのみ表示します', en: 'Only due dates and blockers' },
  'planner.zone.allClear': { ja: '期限切れ・期限間近・ブロック中のタスクはありません', en: 'Nothing overdue, due soon or blocked' },
  'planner.zone.blockedCount': { ja: 'ブロック中のタスクが {n} 件あります', en: '{n} tasks are blocked' },
  'planner.dept.confirmRestore': { ja: '「{name}」を復元して進行中に戻しますか？', en: 'Restore "{name}" back to active?' },
  'planner.project.restored': { ja: '復元しました', en: 'Restored' },
  'planner.project.finishedTag': { ja: '完了案件', en: 'Finished project' },
  'planner.project.restoreHint': { ja: '復元（進行中に戻す）', en: 'Restore (back to active)' },
  'planner.view.cards': { ja: 'カード', en: 'Cards' },
  'planner.gantt.today': { ja: '今日', en: 'Today' },
  'planner.gantt.saturday': { ja: '土曜', en: 'Saturday' },
  'planner.gantt.sunday': { ja: '日曜', en: 'Sunday' },
  'planner.gantt.undatedEmpty': { ja: '日付が未入力のため表示できない項目が {n} 件あります', en: '{n} items cannot be shown because they have no dates' },
  'planner.gantt.undatedRow': { ja: '日付が未入力のため棒を描けない項目が {n} 件あります（{names}）', en: '{n} items have no dates and cannot be drawn ({names})' },
  'planner.myTasks.allTitle': { ja: 'すべてのタスク', en: 'All tasks' },
  'planner.myTasks.allOverdueTitle': { ja: 'すべての期限超過タスク', en: 'All overdue tasks' },
  'planner.myTasks.allDueSoonTitle': { ja: 'すべての期限間近タスク', en: 'All due-soon tasks' },
  'planner.myTasks.allSubtitle': { ja: '担当者を問わず、すべてのタスクを表示します', en: 'Every task, regardless of who is assigned' },
  'planner.myTasks.scopeMine': { ja: '自分のタスク', en: 'My tasks' },
  'planner.myTasks.scopeAll': { ja: '全員のタスク', en: 'Everyone' },
  'planner.myTasks.filter.all': { ja: 'すべて', en: 'All' },
  'planner.myTasks.filter.overdue': { ja: '期限超過', en: 'Overdue' },
  'planner.myTasks.filter.due_soon': { ja: '期限間近', en: 'Due soon' },
  'planner.myTasks.clearDept': { ja: '部署の絞り込みを解除', en: 'Clear department filter' },
  'planner.project.loading': { ja: 'プロジェクトを読み込み中…', en: 'Loading project…' },
  'planner.project.loadFailed': { ja: 'プロジェクトを読み込めませんでした', en: 'Could not load the project' },
  'planner.project.notFound': { ja: 'プロジェクトが見つかりません', en: 'Project not found' },
  'planner.project.notFoundHint': { ja: '指定されたプロジェクト（ID: {id}）は存在しないか、削除された可能性があります。', en: 'The project (ID: {id}) does not exist or may have been deleted.' },
  'planner.project.openFailed': { ja: 'プロジェクトを開けませんでした', en: 'Could not open the project' },
  'planner.project.backToList': { ja: 'プロジェクト一覧に戻る', en: 'Back to projects' },
  'planner.retry': { ja: '再読み込み', en: 'Reload' },
  'planner.tab.docs': { ja: '書類', en: 'Documents' },
  'planner.tab.trace': { ja: '関連レコード', en: 'Related records' },
  'planner.tab.itemflow': { ja: 'アイテムフロー', en: 'Item flow' },
  'planner.task.column': { ja: 'タスク', en: 'Task' },
  'planner.task.range': { ja: '開始〜期限', en: 'Start – due' },
  'planner.task.remark': { ja: '備考', en: 'Notes' },
  'planner.dateOrder': { ja: '開始日より後の日付にしてください', en: 'Must be on or after the start date' },
  'planner.checkFields': { ja: '入力内容をご確認ください', en: 'Please check the highlighted fields' },
  'planner.alerts.empty': { ja: '該当なし', en: 'Nothing here' },
  'planner.alerts.pill': { ja: '要対応 {n} 件', en: '{n} need attention' },
  'planner.alerts.viewAll': { ja: 'すべて表示', en: 'View all' },
  'planner.alerts.viewMore': { ja: '他 {n} 件を表示', en: 'Show {n} more' },
  'planner.alerts.none': { ja: '要対応のタスクはありません', en: 'No tasks need attention' },
  'planner.gantt.item': { ja: '項目', en: 'Item' },
  'planner.gantt.empty': { ja: '表示するデータがありません。', en: 'Nothing to show.' },
  'planner.gantt.emptyTasks': { ja: '期間が設定されたタスクがありません。', en: 'No tasks with dates yet.' },
  'planner.gantt.tasks': { ja: 'タスク {done}/{total}', en: 'Tasks {done}/{total}' },
  'planner.view.list': { ja: '一覧', en: 'List' },
  'planner.view.kanban': { ja: 'カンバン', en: 'Kanban' },
  'planner.view.gantt': { ja: 'ガント', en: 'Gantt' },
  'planner.filter.allStatus': { ja: 'すべての状態', en: 'All statuses' },
  'planner.filter.allPriority': { ja: 'すべての優先度', en: 'All priorities' },
  // project
  'planner.project.new': { ja: '新規プロジェクト', en: 'New project' },
  'planner.project.edit': { ja: 'プロジェクトを編集', en: 'Edit project' },
  'planner.project.name': { ja: 'プロジェクト名', en: 'Project name' },
  'planner.project.nameRequired': { ja: 'プロジェクト名を入力してください', en: 'Project name is required' },
  'planner.project.description': { ja: '説明', en: 'Description' },
  'planner.project.owner': { ja: '責任者', en: 'Owner' },
  'planner.project.members': { ja: 'メンバー', en: 'Members' },
  'planner.project.membersPh': { ja: 'メンバーを選択', en: 'Select members' },
  'planner.project.status': { ja: '状態', en: 'Status' },
  'planner.project.priority': { ja: '優先度', en: 'Priority' },
  'planner.project.start': { ja: '開始日', en: 'Start' },
  'planner.project.end': { ja: '終了日', en: 'End' },
  'planner.project.back': { ja: '部署に戻る', en: 'Back to department' },
  'planner.project.backGeneric': { ja: '前の画面に戻る', en: 'Back' },
  'planner.project.archive': { ja: '完了', en: 'Complete' },
  'planner.project.restore': { ja: '復元', en: 'Restore' },
  'planner.project.confirmArchive': { ja: 'このプロジェクトを完了にしますか？', en: 'Mark this project as completed?' },
  'planner.project.confirmRestore': { ja: 'このプロジェクトを復元しますか？', en: 'Restore this project?' },
  'planner.project.move': { ja: '部署を移動', en: 'Move' },
  'planner.project.moveTitle': { ja: 'プロジェクトを別の部署へ移動', en: 'Move project to another department' },
  'planner.project.moveTarget': { ja: '移動先の部署', en: 'Target department' },
  'planner.project.moved': { ja: '部署を移動しました', en: 'Project moved' },
  'planner.project.delete': { ja: '削除', en: 'Delete' },
  'planner.project.confirmDelete': { ja: '「{name}」を削除しますか？タスクもすべて削除され、元に戻せません。', en: 'Delete "{name}"? All its tasks will be permanently removed.' },
  'planner.project.deleted': { ja: 'プロジェクトを削除しました', en: 'Project deleted' },
  'planner.projectStatus.active': { ja: '進行中', en: 'Active' },
  'planner.projectStatus.on_hold': { ja: '保留', en: 'On hold' },
  'planner.projectStatus.completed': { ja: '完了', en: 'Completed' },
  'planner.projectStatus.finished': { ja: '完了済み', en: 'Finished' },
  // task
  'planner.task.new': { ja: '新規タスク', en: 'New task' },
  'planner.task.edit': { ja: 'タスクを編集', en: 'Edit task' },
  'planner.task.title': { ja: 'タスク名', en: 'Task name' },
  'planner.task.titleRequired': { ja: 'タスク名を入力してください', en: 'Task name is required' },
  'planner.task.priority': { ja: '優先度', en: 'Priority' },
  'planner.task.status': { ja: '状態', en: 'Status' },
  'planner.task.assignee': { ja: '担当者', en: 'Assignee' },
  'planner.task.members': { ja: 'メンバー', en: 'Members' },
  'planner.task.membersPh': { ja: 'メンバーを選択', en: 'Select members' },
  'planner.task.start': { ja: '開始日', en: 'Start' },
  'planner.task.due': { ja: '期限', en: 'Due' },
  'planner.task.notes': { ja: 'メモ', en: 'Notes' },
  'planner.task.empty': { ja: 'タスクがありません。', en: 'No tasks yet.' },
  'planner.task.confirmDelete': { ja: '「{name}」を削除しますか？', en: 'Delete "{name}"?' },
  'planner.priority.low': { ja: '低', en: 'Low' },
  'planner.priority.medium': { ja: '中', en: 'Medium' },
  'planner.priority.high': { ja: '高', en: 'High' },
  'planner.priority.urgent': { ja: '緊急', en: 'Urgent' },
  'planner.taskStatus.todo': { ja: '未着手', en: 'To do' },
  'planner.taskStatus.in_progress': { ja: '進行中', en: 'In progress' },
  'planner.taskStatus.blocked': { ja: 'ブロック', en: 'Blocked' },
  'planner.taskStatus.done': { ja: '完了', en: 'Done' },
  // people
  'planner.people.none': { ja: '未設定', en: 'Unassigned' },
  'planner.people.selected': { ja: '{n}名選択', en: '{n} selected' },
  'planner.people.searchPh': { ja: '名前・部署で検索', en: 'Search name / department' },
  'planner.people.noMatch': { ja: '該当する社員がいません', en: 'No matching employees' },
  // shared verbs
  'planner.save': { ja: '保存', en: 'Save' },
  'planner.saving': { ja: '保存中…', en: 'Saving…' },
  'planner.saved': { ja: '保存しました', en: 'Saved' },
  'planner.cancel': { ja: 'キャンセル', en: 'Cancel' },
  'planner.edit': { ja: '編集', en: 'Edit' },
  'planner.delete': { ja: '削除', en: 'Delete' },
  'planner.deleted': { ja: '削除しました', en: 'Deleted' },
  'planner.error': { ja: 'エラーが発生しました', en: 'Something went wrong' },
  // 過去関連作業 (Archived Related Work)
  'planner.archive.title': { ja: '過去関連作業', en: 'Archived Related Work' },
  'planner.archive.subtitle': { ja: 'Odoo時代や旧システムの作業履歴を、現在のプロジェクトとは分けて表示します。', en: 'Historical work from Odoo or legacy systems, displayed separately from current project tasks.' },
  'planner.archive.referenceOnly': { ja: '参考情報のみ・現在の進捗には含めません', en: 'Reference only - not counted in current progress' },
  'planner.archive.historicalContext': { ja: '過去コンテキスト', en: 'Historical Context' },
  'planner.archive.sourceSystem': { ja: '参照元システム', en: 'Source System' },
  'planner.archive.sourceFile': { ja: '参照元ファイル', en: 'Source File' },
  'planner.archive.sourceArticle': { ja: '参照元記事', en: 'Source Article' },
  'planner.archive.confidence': { ja: '一致信頼度', en: 'Confidence' },
  'planner.archive.reviewStatus': { ja: 'レビュー状態', en: 'Review Status' },
  'planner.archive.relationshipType': { ja: '関連種別', en: 'Relationship Type' },
  'planner.archive.matchReason': { ja: '一致理由', en: 'Match Reason' },
  'planner.archive.excerpt': { ja: '原文抜粋', en: 'Raw Excerpt' },
  'planner.archive.reviewTitle': { ja: '過去データ連携レビュー', en: 'Archived Data Link Review' },
  'planner.archive.dryRun': { ja: '試行インポート', en: 'Dry Run' },
  'planner.archive.dryRunPdf': { ja: 'PDFレポート抽出データで試行インポート', en: 'Dry run with the bundled PDF report data' },
  'planner.archive.importHeading': { ja: 'インポート（Odoo Knowledge XLSX / JSON）', en: 'Import (Odoo Knowledge XLSX / JSON)' },
  'planner.archive.importHistory': { ja: 'インポート履歴', en: 'Import history' },
  'planner.archive.rolledBack': { ja: '取り消し済み', en: 'Rolled back' },
  'planner.archive.commit': { ja: 'インポート実行', en: 'Commit Import' },
  'planner.archive.rollback': { ja: 'インポート取り消し', en: 'Rollback Import' },
  'planner.archive.includeArchived': { ja: '過去関連作業を含める', en: 'Include archived related work' },
  'planner.archive.autoApproveExact': { ja: '完全一致（高信頼度）を自動承認する', en: 'Auto-approve exact matches' },
  'planner.archive.approve': { ja: '承認', en: 'Approve' },
  'planner.archive.reject': { ja: '却下', en: 'Reject' },
  'planner.archive.candidate': { ja: '候補プロジェクト', en: 'Candidate Project' },
  'planner.archive.reviewerNote': { ja: 'レビュアーメモ', en: 'Reviewer Note' },
  'planner.archive.bulkApprove': { ja: '選択を一括承認', en: 'Bulk Approve Selected' },
  'planner.archive.noRecords': { ja: '過去関連作業はありません', en: 'No archived related work' },
  'planner.archive.editTitle': { ja: '過去データリンクを編集', en: 'Edit archive link' },
  'planner.archive.pendingLink': { ja: 'レビュー待ちが{n}件あります → 過去データ連携レビューへ', en: '{n} records pending review → open Archived Data Link Review' },
  'planner.archive.status.pending_review': { ja: 'レビュー待ち', en: 'Pending Review' },
  'planner.archive.status.approved_link': { ja: '承認済みリンク', en: 'Approved Link' },
  'planner.archive.status.rejected_link': { ja: '却下済みリンク', en: 'Rejected Link' },
  'planner.archive.status.needs_more_info': { ja: '追加情報が必要', en: 'Needs More Info' },
  'planner.archive.conf.high': { ja: '高', en: 'High' },
  'planner.archive.conf.medium': { ja: '中', en: 'Medium' },
  'planner.archive.conf.low': { ja: '低', en: 'Low' },
  'planner.archive.conf.unmatched': { ja: '未一致', en: 'Unmatched' },
  'planner.archive.rel.historical_context': { ja: '過去コンテキスト', en: 'Historical Context' },
  'planner.archive.rel.predecessor_project': { ja: '前身プロジェクト', en: 'Predecessor Project' },
  'planner.archive.rel.related_subtask': { ja: '関連サブタスク', en: 'Related Past Subtask' },
  'planner.archive.rel.similar_equipment': { ja: '類似設備', en: 'Similar Equipment' },
  'planner.archive.rel.completed_legacy_project': { ja: '完了済み旧プロジェクト', en: 'Completed Legacy Project' },
  'planner.archive.rel.work_log_reference': { ja: '作業ログ参照', en: 'Work Log Reference' },
  'planner.archive.rel.unmatched_archive': { ja: '未一致アーカイブ', en: 'Unmatched Archive' },
  'planner.archive.status.old_project_created': { ja: 'アーカイブ済み旧プロジェクト作成済み', en: 'Archived old project created' },
  'planner.oldproj.title': { ja: '旧プロジェクト保管庫', en: 'Old Project Vault' },
  'planner.oldproj.subtitle': { ja: 'Odoo時代の記事から作成した旧プロジェクトの記録です。現行プロジェクトの進捗・件数には影響しません。', en: 'Historical projects created from old Odoo articles. Does not affect current projects.' },
  'planner.oldproj.create': { ja: 'アーカイブ済み旧プロジェクトを作成', en: 'Create archived old project' },
  'planner.oldproj.createShort': { ja: '旧プロジェクト化', en: 'To old project' },
  'planner.oldproj.extracting': { ja: 'AIが記事から情報を抽出しています…', en: 'AI is extracting details from the article…' },
  'planner.oldproj.method.ai': { ja: 'AI抽出', en: 'AI extracted' },
  'planner.oldproj.method.rule': { ja: 'ルール抽出', en: 'Rule-based' },
  'planner.oldproj.name': { ja: 'プロジェクト名', en: 'Project Name' },
  'planner.oldproj.dateStart': { ja: '開始日', en: 'Start Date' },
  'planner.oldproj.dateEnd': { ja: '終了日', en: 'End Date' },
  'planner.oldproj.people': { ja: '関係者', en: 'People' },
  'planner.oldproj.peopleHint': { ja: '「、」区切りで複数入力', en: 'Separate multiple with 、' },
  'planner.oldproj.department': { ja: '部署', en: 'Department' },
  'planner.oldproj.tags': { ja: 'タグ', en: 'Tags' },
  'planner.oldproj.tagsHint': { ja: 'カンマ区切りで複数入力', en: 'Comma-separated' },
  'planner.oldproj.summary': { ja: '概要', en: 'Summary' },
  'planner.oldproj.created': { ja: 'アーカイブ済み旧プロジェクトを作成しました', en: 'Archived old project created' },
  'planner.oldproj.empty': { ja: '旧プロジェクトはまだありません', en: 'No old projects yet' },
  'planner.oldproj.search': { ja: '旧プロジェクトを検索…', en: 'Search old projects…' },
  'planner.oldproj.count': { ja: '{n}件', en: '{n} items' },
  'planner.oldproj.sourceArticle': { ja: '元記事', en: 'Source Article' },
  'planner.oldproj.sourceExcerpt': { ja: '元記事の原文', en: 'Original article text' },
  'planner.oldproj.linkedProject': { ja: '関連付け先プロジェクト', en: 'Linked Project' },
  'planner.oldproj.linkToProject': { ja: '現行プロジェクトに関連付け（参考情報）', en: 'Link to active project (reference)' },
  'planner.oldproj.noLink': { ja: '（関連付けなし）', en: '(no link)' },
  'planner.oldproj.edit': { ja: '編集', en: 'Edit' },
  'planner.oldproj.delete': { ja: '削除', en: 'Delete' },
  'planner.oldproj.deleteConfirm': { ja: 'この旧プロジェクトを削除すると、元の記事は「レビュー待ち」に戻ります。よろしいですか？', en: 'Deleting this old project returns the source article to pending review. Continue?' },
  'planner.oldproj.deleted': { ja: '削除しました（元記事はレビュー待ちに戻りました）', en: 'Deleted (source article returned to pending review)' },
  'planner.oldproj.viewInVault': { ja: '保管庫で表示', en: 'View in vault' },



  // ── 製造管理 — nav ──
  'mfg.title': { ja: '製造管理', en: 'Manufacturing' },
  'mfg.subtitle': { ja: '在庫・ロット・倉庫を一元管理', en: 'Inventory, lots & warehouse in one place' },
  'mfg.nav.inventory': { ja: '在庫管理', en: 'Inventory' },
  'mfg.nav.suppliers': { ja: '仕入先', en: 'Suppliers' },
  'mfg.nav.locations': { ja: '倉庫・棚', en: 'Locations' },
  'mfg.nav.moves': { ja: '入出庫履歴', en: 'Stock History' },
  'mfg.nav.scan': { ja: 'スキャン', en: 'Scan' },

  // ── ドキュメント — サイドバー（やりたいこと順・正式名） ──
  'docs.navGroup.find': { ja: '検索・閲覧', en: 'Search & browse' },
  'docs.navGroup.intake': { ja: '取り込み', en: 'Intake' },
  'docs.navGroup.organise': { ja: '整理・管理', en: 'Organise & manage' },
  'docs.navGroup.other': { ja: 'その他', en: 'Other' },
  'docs.nav.recent': { ja: '最近の書類', en: 'Recent documents' },
  'docs.nav.all': { ja: 'すべての書類', en: 'All documents' },
  'docs.nav.ask': { ja: 'AI検索', en: 'AI search' },
  'docs.nav.scan': { ja: 'スキャナー受信箱', en: 'Scanner inbox' },
  'docs.nav.nas': { ja: 'NAS参照（AI検索対象）', en: 'NAS reference (AI search)' },
  'docs.nav.drawingRevs': { ja: '図面の改訂管理', en: 'Drawing revisions' },
  'docs.nav.shares': { ja: '共有中（外部共有）', en: 'External shares' },
  'docs.nav.bundles': { ja: 'バインダー', en: 'Binders' },
  'docs.nav.responsibilities': { ja: '担当者の一括確認', en: 'Bulk owner review' },
  'docs.nav.requests': { ja: '未提出書類', en: 'Outstanding documents' },
  'docs.nav.trash': { ja: 'ゴミ箱', en: 'Trash' },

  // ── 製造管理 — common ──
  'mfg.new': { ja: '新規', en: 'New' },
  'mfg.edit': { ja: '編集', en: 'Edit' },
  'mfg.delete': { ja: '削除', en: 'Delete' },
  'mfg.save': { ja: '保存', en: 'Save' },
  'mfg.saving': { ja: '保存中…', en: 'Saving…' },
  'mfg.cancel': { ja: 'キャンセル', en: 'Cancel' },
  'mfg.search': { ja: '検索', en: 'Search' },
  'mfg.close': { ja: '閉じる', en: 'Close' },
  'mfg.all': { ja: 'すべて', en: 'All' },
  'mfg.none': { ja: 'なし', en: 'None' },
  'mfg.optional': { ja: '任意', en: 'optional' },
  'mfg.saved': { ja: '保存しました', en: 'Saved' },
  'mfg.deleted': { ja: '削除しました', en: 'Deleted' },
  'mfg.error': { ja: 'エラーが発生しました', en: 'Something went wrong' },
  'mfg.attach.title': { ja: '添付ファイル', en: 'Attachments' },
  'mfg.attach.itemTitle': { ja: '図面・仕様', en: 'Drawings / Specs' },
  'mfg.attach.itemHint': { ja: 'PDF・Excel・画像（最大25MB）。この品目を使う全ての製造オーダーで表示されます。', en: 'PDF / Excel / images (max 25MB). Shown on every work order using this item.' },
  'mfg.attach.productTitle': { ja: '製品の図面・仕様', en: 'Product drawings / specs' },
  'mfg.attach.productHint': { ja: '製品（品目）に紐づく図面です。全オーダー共通で表示されます。', en: 'Drawings linked to the product item, shared across all work orders.' },
  'mfg.attach.woTitle': { ja: 'このオーダーの添付', en: 'Work-order attachments' },
  'mfg.attach.upload': { ja: 'アップロード', en: 'Upload' },
  'mfg.attach.uploaded': { ja: 'アップロードしました', en: 'Uploaded' },
  'mfg.attach.deleted': { ja: '削除しました', en: 'Deleted' },
  'mfg.attach.view': { ja: '表示', en: 'View' },
  'mfg.attach.download': { ja: 'ダウンロード', en: 'Download' },
  'mfg.attach.viewFailed': { ja: 'プレビューを読み込めませんでした', en: 'Could not load preview' },
  'mfg.attach.viewUnsupported': { ja: 'この形式はプレビューできません。ダウンロードしてください。', en: 'This format cannot be previewed. Please download.' },
  'mfg.attach.sheetEmpty': { ja: 'このシートは空です', en: 'This sheet is empty' },
  'mfg.attach.empty': { ja: '添付ファイルはありません', en: 'No attachments yet' },
  'mfg.attach.afterSave': { ja: '※ ファイルは品目を保存した後に添付できます。', en: 'Files can be attached after the item is saved.' },
  'mfg.attach.confirmDelete': { ja: '「{name}」を削除しますか？', en: 'Delete "{name}"?' },
  'mfg.yes': { ja: 'はい', en: 'Yes' },
  'mfg.no': { ja: 'いいえ', en: 'No' },
  'mfg.cols.title': { ja: '表示項目', en: 'Columns' },
  'mfg.cols.show': { ja: '表示する列（チェック＝表示 / ▲▼＝並べ替え）', en: 'Visible columns (check = show / ▲▼ = reorder)' },
  'mfg.cols.alert': { ja: '在庫アラート', en: 'Stock alert' },
  'mfg.cols.defaultSort': { ja: '既定の並び順', en: 'Default sort' },
  'mfg.cols.none': { ja: 'なし', en: 'None' },
  'mfg.cols.asc': { ja: '昇順', en: 'Ascending' },
  'mfg.cols.desc': { ja: '降順', en: 'Descending' },
  'mfg.cols.reset': { ja: 'デフォルトに戻す', en: 'Reset to default' },
  'mfg.cols.done': { ja: '完了', en: 'Done' },

  'mfg.confirmDelete': { ja: '「{name}」を削除しますか？', en: 'Delete "{name}"?' },
  'mfg.confirmForceDelete': { ja: '「{name}」には在庫が残っています。\n\n強制削除すると、この品目と関連する全てのロット・在庫履歴が完全に削除され、元に戻せません。\n\n本当に強制削除しますか？', en: '"{name}" still has stock.\n\nForce-deleting will permanently remove this item and ALL of its lots and stock history. This cannot be undone.\n\nReally force-delete?' },
  'mfg.forceDeleted': { ja: '強制削除しました（在庫・履歴も削除）', en: 'Force-deleted (stock & history removed)' },
  'mfg.restore': { ja: '復元', en: 'Restore' },
  'mfg.restored': { ja: '復元しました', en: 'Restored' },
  'mfg.deletedItems.btn': { ja: '削除済み', en: 'Deleted' },
  'mfg.deletedItems.title': { ja: '削除済み品目', en: 'Deleted items' },
  'mfg.deletedItems.desc': { ja: '削除した品目はここから復元できます。', en: 'Items you deleted can be restored from here.' },
  'mfg.deletedItems.empty': { ja: '削除済みの品目はありません', en: 'No deleted items' },
  'mfg.deletedItems.permanent': { ja: '完全に削除', en: 'Delete permanently' },
  'mfg.confirmPermanent': { ja: '「{name}」を完全に削除しますか？\n\nこの操作は元に戻せません。', en: 'Permanently delete "{name}"?\n\nThis cannot be undone.' },

  // ── 製造管理 — stats ──
  'mfg.stats.items': { ja: '品目数', en: 'Items' },
  'mfg.stats.lowStock': { ja: '在庫不足', en: 'Low stock' },
  'mfg.stats.overstock': { ja: '過剰在庫', en: 'Overstock' },
  'mfg.stats.expiring': { ja: '期限間近ロット', en: 'Expiring lots' },
  'mfg.stats.value': { ja: '在庫評価額', en: 'Stock value' },
  'mfg.stats.needsInput': { ja: '要入力', en: 'Needs input' },

  // ── 製造管理 — item types ──
  'mfg.type.raw': { ja: '原材料', en: 'Raw material' },
  'mfg.type.undefined': { ja: '未設定', en: 'Not set' },
  'mfg.type.null': { ja: '未設定', en: 'Not set' },
  'mfg.type.purchased_part': { ja: '購入部品', en: 'Purchased part' },
  'mfg.type.processed_part': { ja: '加工部品', en: 'Processed part' },
  'mfg.type.wip': { ja: '仕掛品', en: 'WIP' },
  'mfg.type.semifinished': { ja: '半製品', en: 'Semifinished' },
  'mfg.type.finished': { ja: '製品', en: 'Finished product' },
  'mfg.type.consumable': { ja: '消耗品', en: 'Consumable' },
  'mfg.type.sub_material': { ja: '副資材', en: 'Sub-material' },
  'mfg.processing.section': { ja: '加工情報', en: 'Processing info' },
  'mfg.processing.type': { ja: '加工区分', en: 'Processing type' },
  'mfg.processing.in_house': { ja: '社内加工', en: 'In-house' },
  'mfg.processing.subcontracted': { ja: '外注加工', en: 'Subcontracted' },
  'mfg.subcontractor': { ja: '外注先', en: 'Subcontractor' },
  'mfg.subcontractProcess': { ja: '外注加工内容', en: 'Process detail' },
  'mfg.subcontractUnitPrice': { ja: '外注単価', en: 'Subcontract unit price' },
  'mfg.subcontractLeadDays': { ja: '標準リードタイム（日）', en: 'Lead time (days)' },
  'mfg.supplier.type': { ja: '取引区分', en: 'Transaction type' },
  'mfg.supplierType.vendor': { ja: '仕入先', en: 'Vendor' },
  'mfg.supplierType.subcontractor': { ja: '外注先', en: 'Subcontractor' },
  'mfg.supplierType.both': { ja: '仕入先＋外注先', en: 'Vendor + Subcontractor' },
  'mfg.nav.categories': { ja: 'カテゴリ管理', en: 'Categories' },
  'mfg.nav.uoms': { ja: '単位管理', en: 'Units' },
  'mfg.navGroup.inventory': { ja: '在庫', en: 'Inventory' },
  'mfg.navGroup.production': { ja: '製造', en: 'Manufacturing' },
  'mfg.navGroup.equipment': { ja: '設備', en: 'Equipment' },
  'mfg.navGroup.master': { ja: 'マスター管理', en: 'Master data' },
  'mfg.nav.master': { ja: 'マスター管理', en: 'Master data' },
  'mfg.master.desc': { ja: '仕入先・倉庫棚・カテゴリ・単位をまとめて管理します。', en: 'Manage suppliers, locations, categories & units in one place.' },
  'mfg.uom.title': { ja: '単位', en: 'Units' },
  'mfg.uom.desc': { ja: '品目で使用する単位の追加・編集・並び替え・削除ができます。', en: 'Add, edit, reorder and delete units of measure.' },
  'mfg.uom.name': { ja: '単位', en: 'Unit' },
  'mfg.uom.namePh': { ja: '単位を入力（例: 個, 本, kg）', en: 'Enter a unit (e.g. pcs, m, kg)' },
  'mfg.uom.add': { ja: '単位を追加', en: 'Add unit' },
  'mfg.uom.empty': { ja: '単位がありません', en: 'No units' },
  'mfg.uom.usage': { ja: '使用品目数', en: 'Items' },
  'mfg.uom.searchPh': { ja: '検索 または 入力して新規追加', en: 'Search or type to add' },
  'mfg.uom.createNamed': { ja: '「{name}」を新規追加', en: 'Add "{name}"' },
  'mfg.uom.noMatch': { ja: '一致する単位がありません', en: 'No matching unit' },
  'mfg.category.title': { ja: 'カテゴリ管理', en: 'Category management' },
  'mfg.category.desc': { ja: '品目カテゴリの追加・編集・並び替え・削除ができます。', en: 'Add, edit, reorder and delete item categories.' },
  'mfg.category.name': { ja: 'カテゴリ名', en: 'Category name' },
  'mfg.category.namePh': { ja: 'カテゴリ名を入力', en: 'Enter category name' },
  'mfg.category.addNew': { ja: '＋ 新規追加', en: '+ Add new' },
  'mfg.category.searchPh': { ja: '検索 または 入力して新規追加', en: 'Search or type to add' },
  'mfg.category.createNamed': { ja: '「{name}」を新規追加', en: 'Add "{name}"' },
  'mfg.category.noMatch': { ja: '一致するカテゴリがありません', en: 'No matching category' },
  'mfg.maker.searchPh': { ja: 'メーカーを検索 または 入力して追加', en: 'Search maker or type to add' },
  'mfg.maker.createNamed': { ja: 'メーカー「{name}」を追加', en: 'Add maker "{name}"' },
  'mfg.maker.noMatch': { ja: '一致するメーカーがありません', en: 'No matching maker' },
  // iter_143f · maker master editor (settings › master)
  'mfg.maker.title': { ja: 'メーカー', en: 'Makers' },
  'mfg.maker.desc': { ja: '品目に使うメーカー名を追加・編集・並び替え・削除できます。', en: 'Add, edit, reorder and delete makers used on items.' },
  'mfg.maker.name': { ja: 'メーカー', en: 'Maker' },
  'mfg.maker.namePh': { ja: 'メーカー名を入力（例: Panasonic, OMRON, Schneider）', en: 'Enter maker name (e.g. Panasonic, OMRON)' },
  'mfg.maker.add': { ja: 'メーカーを追加', en: 'Add maker' },
  'mfg.maker.empty': { ja: 'メーカーがまだ登録されていません', en: 'No makers yet' },
  'mfg.maker.usage': { ja: '使用品目数', en: 'Items' },
  'mfg.owner.searchPh': { ja: '担当者を検索', en: 'Search person in charge' },
  'mfg.owner.noMatch': { ja: '一致する担当者がありません', en: 'No matching person' },
  'mfg.supplier.searchPh': { ja: '仕入先を検索（名前・カナ・略称）', en: 'Search supplier (name / kana / short)' },
  'mfg.supplier.noMatch': { ja: '一致する仕入先がありません', en: 'No matching supplier' },
  'mfg.category.add': { ja: 'カテゴリを追加', en: 'Add category' },
  'mfg.category.empty': { ja: 'カテゴリがありません', en: 'No categories' },
  'mfg.category.usage': { ja: '使用品目数', en: 'Items' },
  'mfg.category.deleteBlocked': { ja: '使用中のカテゴリは削除できません', en: 'Cannot delete a category in use' },
  'mfg.category.moveUp': { ja: '上へ', en: 'Move up' },
  'mfg.category.moveDown': { ja: '下へ', en: 'Move down' },
  'mfg.bom.unitCost': { ja: '単価', en: 'Unit cost' },
  'mfg.bom.lineCost': { ja: '金額', en: 'Amount' },
  'mfg.bom.totalCost': { ja: '推定原価合計', en: 'Est. total cost' },
  'shizai.orderType.purchase': { ja: '購入発注', en: 'Purchase order' },
  'shizai.orderType.subcontract': { ja: '外注発注', en: 'Subcontract order' },
  'shizai.orderTypeShort.purchase': { ja: '購入', en: 'Purchase' },
  'shizai.orderTypeShort.subcontract': { ja: '外注', en: 'Subcontract' },
  'shizai.doc.poTitle.purchase': { ja: '発注書', en: 'Purchase Order' },
  'shizai.doc.poTitle.subcontract': { ja: '外注発注書', en: 'Subcontract Order' },
  'shizai.order.orderType': { ja: '発注区分', en: 'Order type' },
  'shizai.order.subcontractor': { ja: '外注先', en: 'Subcontractor' },
  'shizai.order.subcontractHint': { ja: '外注先のみ表示中', en: 'Showing subcontractors only' },
  'mfg.dash.stat.subcontract': { ja: '外注依存率', en: 'Subcontract %' },

  // ── 製造管理 — item fields ──
  'mfg.item.sku': { ja: 'SKU', en: 'SKU' },
  'mfg.item.name': { ja: '品目名', en: 'Item name' },
  'mfg.item.type': { ja: 'タイプ', en: 'Type' },
  'mfg.item.category': { ja: 'カテゴリ', en: 'Category' },
  'mfg.item.uom': { ja: '単位', en: 'Unit' },
  'mfg.item.barcode': { ja: 'バーコード', en: 'Barcode' },
  'mfg.item.supplier': { ja: '仕入先', en: 'Supplier' },
  'mfg.item.maker': { ja: 'メーカー', en: 'Maker' },
  'mfg.item.model': { ja: '型式', en: 'Model' },
  'mfg.item.makerPn': { ja: 'メーカー品番', en: 'Maker part no.' },
  'mfg.item.drawingNo': { ja: '図面番号', en: 'Drawing no.' },
  'mfg.item.refDes': { ja: '基板記号', en: 'Ref designators' },
  'mfg.item.datasheet': { ja: 'URL', en: 'URL' },
  'mfg.item.open': { ja: '開く', en: 'Open' },
  'mfg.itemPicker.searchPh': { ja: '品名・SKU・型式・品番・メーカーで検索', en: 'Search by name, SKU, model, part no., maker' },
  'mfg.itemPicker.noMatch': { ja: '該当する品目がありません', en: 'No matching items' },
  'mfg.itemPicker.allDepts': { ja: '全部門から検索', en: 'Search all departments' },
  'mfg.itemPicker.deptOnly': { ja: '現在の部門のみ', en: 'Current department only' },
  'mfg.itemPicker.uncategorized': { ja: '未分類', en: 'Uncategorized' },
  'mfg.itemPicker.loadingAll': { ja: '全部門を読み込み中…', en: 'Loading all departments…' },
  'mfg.itemPicker.countHint': { ja: '{count} 件', en: '{count} items' },
  'mfg.itemPicker.searchTitle': { ja: '品目を検索', en: 'Search items' },
  'mfg.itemPicker.tip': { ja: '↑↓ で移動 · Enter で選択 · Esc で閉じる', en: '↑↓ move · Enter select · Esc close' },
  'mfg.itemPicker.refine': { ja: '検索で絞り込めます', en: 'Type to refine' },
  'mfg.itemPicker.searching': { ja: '検索中…', en: 'Searching…' },
  'mfg.itemPicker.open': { ja: '検索して選択', en: 'Search & select' },
  'mfg.itemPicker.change': { ja: '変更', en: 'Change' },
  'mfg.item.departments': { ja: '取扱部門', en: 'Departments' },
  'mfg.item.departmentsHint': { ja: '未選択の場合は全部門に表示されます', en: 'Shown in all departments if none selected' },
  'mfg.item.reorderPoint': { ja: '発注点', en: 'Reorder point' },
  'mfg.item.maxStock': { ja: '最大在庫', en: 'Max stock' },
  'mfg.item.reorderQty': { ja: '発注点補充数', en: 'Reorder qty' },
  'mfg.item.packSize': { ja: '入数', en: 'Pack size' },
  'mfg.item.packUom': { ja: '包装単位', en: 'Pack unit' },
  'mfg.item.packHint': { ja: '例: 5個 ＝ 1袋。左が空欄なら通常の単位で発注', en: 'e.g. 5 pcs = 1 bag. Blank = order by base unit' },
  'mfg.item.defaultLocation': { ja: '既定ロケーション', en: 'Default location' },
  'mfg.item.lotTracked': { ja: 'ロット管理する', en: 'Lot tracked' },
  'mfg.item.cost': { ja: '単価', en: 'Unit cost' },
  'mfg.item.cycleTime': { ja: '標準サイクル(秒/個)', en: 'Cycle time (s/pc)' },
  'mfg.item.cycleTimePh': { ja: 'OEE用', en: 'For OEE' },
  'mfg.item.notes': { ja: '備考', en: 'Notes' },
  'mfg.item.onHand': { ja: '在庫数', en: 'On hand' },
  'mfg.item.new': { ja: '品目を登録', en: 'New item' },
  'mfg.item.edit': { ja: '品目を編集', en: 'Edit item' },
  'mfg.item.advanced': { ja: '詳細設定', en: 'Advanced settings' },
  'mfg.item.advancedHint': { ja: '発注点・入数・メーカー・部門など', en: 'Reorder point, pack size, maker, departments, etc.' },

  // ── 製造管理 — badges ──
  'mfg.badge.low': { ja: '在庫不足', en: 'Low' },
  'mfg.badge.over': { ja: '過剰', en: 'Over' },
  'mfg.badge.ok': { ja: '適正', en: 'OK' },

  // ── 製造管理 — inventory ──
  'mfg.inventory.searchPh': { ja: '品目名・SKU・バーコードで検索', en: 'Search name, SKU or barcode' },
  'mfg.inventory.empty': { ja: '品目がありません', en: 'No items yet' },
  'mfg.inventory.lowOnly': { ja: '在庫不足のみ', en: 'Low stock only' },
  'mfg.inventory.needsInputOnly': { ja: '要入力のみ', en: 'Needs input only' },
  'mfg.inventory.needsInputBanner': {
    ja: '要入力 {count}件 — 発注点・保管場所・仕入先・単位のいずれかが未入力です（保存はできます）',
    en: '{count} items need input — 発注点 / 保管場所 / 仕入先 / 単位 is missing (saving is still allowed)',
  },
  'mfg.item.needsInput': { ja: '要入力', en: 'Needs input' },
  'mfg.item.missingFields': { ja: '未入力', en: 'Missing' },
  'mfg.import.settingsTitle': { ja: '取り込みの管理者設定', en: 'Import admin settings' },
  'mfg.import.defaultSkuRule': { ja: '既定の品番ルール', en: 'Default 品番 rule' },
  'mfg.import.defaultSkuRuleHint': {
    ja: '品番が空の行にこのテンプレートを充てます。プレビューで行ごとに変更できます。',
    en: 'Rows with an empty 品番 get this template. You can change it per row in the preview.',
  },
  'mfg.import.requireSku': { ja: '品番の必須チェックを有効にする', en: 'Require 品番 (validation)' },
  'mfg.import.requireSkuHint': {
    ja: '既定は OFF。ONにすると品番も品番ルールも無い行はエラーになります。',
    en: 'OFF by default. When ON, rows with neither 品番 nor a rule become errors.',
  },
  'mfg.import.settingsSaved': { ja: '取り込み設定を保存しました', en: 'Import settings saved' },

  // ── 製造管理 — lots & stock ops ──
  'mfg.item.lots': { ja: 'ロット一覧', en: 'Lots' },
  'mfg.lot.no': { ja: 'ロット番号', en: 'Lot No.' },
  'mfg.lot.location': { ja: 'ロケーション', en: 'Location' },
  'mfg.lot.qty': { ja: '数量', en: 'Qty' },
  'mfg.lot.expiry': { ja: '有効期限', en: 'Expiry' },
  'mfg.lot.received': { ja: '入荷日', en: 'Received' },
  'mfg.lot.noLots': { ja: 'ロットがありません', en: 'No lots yet' },
  'mfg.action.receive': { ja: '入荷', en: 'Receive' },
  'mfg.action.adjust': { ja: '調整', en: 'Adjust' },
  'mfg.action.transfer': { ja: '移動', en: 'Transfer' },
  'mfg.action.label': { ja: 'ラベル', en: 'Label' },
  'mfg.action.print': { ja: '印刷', en: 'Print' },
  'mfg.action.download': { ja: 'ダウンロード', en: 'Download' },
  'mfg.label.print': { ja: 'ラベル印刷', en: 'Print label' },
  'mfg.label.printRow': { ja: 'ラベル印刷', en: 'Print label' },
  'mfg.label.bulkPrint': { ja: '一括ラベル印刷', en: 'Bulk print labels' },
  'mfg.label.size': { ja: 'ラベルサイズ', en: 'Label size' },
  'mfg.label.barcodeFormat': { ja: 'バーコード形式', en: 'Barcode format' },
  'mfg.label.copies': { ja: '枚数', en: 'Copies' },
  'mfg.label.preview': { ja: 'プレビュー', en: 'Preview' },
  'mfg.label.printButton': { ja: '印刷', en: 'Print' },
  'mfg.label.dieCut': { ja: '定型ラベル', en: 'Die-cut labels' },
  'mfg.label.continuous': { ja: '長尺テープ', en: 'Continuous tape' },
  'mfg.label.popupBlocked': { ja: 'ポップアップがブロックされました。ブラウザで許可してください。', en: 'Popup blocked. Please allow popups in your browser.' },
  'mfg.label.size.29x62': { ja: '小型 29×62mm (DK-11209)', en: 'Small 29×62mm (DK-11209)' },
  'mfg.label.size.29x90': { ja: '標準 29×90mm (DK-11201)', en: 'Standard 29×90mm (DK-11201)' },
  'mfg.label.size.38x90': { ja: '大型 38×90mm (DK-11208)', en: 'Large 38×90mm (DK-11208)' },
  'mfg.label.size.62x100': { ja: '特大 62×100mm (DK-11202)', en: 'XL 62×100mm (DK-11202)' },
  'mfg.label.size.23x23': { ja: '正方形小 23×23mm (DK-11221)', en: 'Square S 23×23mm (DK-11221)' },
  'mfg.label.size.58x58': { ja: '正方形大 58×58mm (DK-11207)', en: 'Square L 58×58mm (DK-11207)' },
  'mfg.label.size.29xAuto': { ja: 'テープ 29mm幅 (DK-22210)', en: 'Tape 29mm (DK-22210)' },
  'mfg.label.size.38xAuto': { ja: 'テープ 38mm幅 (DK-22225)', en: 'Tape 38mm (DK-22225)' },
  'mfg.label.size.62xAuto': { ja: 'テープ 62mm幅 (DK-22205)', en: 'Tape 62mm (DK-22205)' },

  'mfg.receive.title': { ja: '入荷登録', en: 'Receive stock' },
  'mfg.receive.lotAuto': { ja: '空欄で自動採番', en: 'auto-generated if blank' },
  'mfg.receive.done': { ja: '入荷を登録しました', en: 'Stock received' },
  'mfg.adjust.title': { ja: '在庫調整', en: 'Adjust stock' },
  'mfg.adjust.newQty': { ja: '調整後の数量', en: 'New quantity' },
  'mfg.adjust.reason': { ja: '理由', en: 'Reason' },
  'mfg.adjust.done': { ja: '在庫を調整しました', en: 'Stock adjusted' },
  'mfg.transfer.title': { ja: 'ロケーション移動', en: 'Transfer' },
  'mfg.transfer.toLocation': { ja: '移動先', en: 'To location' },
  'mfg.transfer.done': { ja: '移動しました', en: 'Transferred' },

  // ── 製造管理 — suppliers ──
  'mfg.supplier.name': { ja: '仕入先名', en: 'Name' },
  'mfg.supplier.nameEn': { ja: '英語表記（任意）', en: 'English name (optional)' },
  // T3 · IPマップのツールチップ（数字と値が入るのでモデルに訳させない）
  'it.ip.purpose': { ja: '用途', en: 'Purpose' },
  'it.ip.user': { ja: '使用者', en: 'User' },
  'it.ip.device': { ja: '端末', en: 'Device' },
  'it.ip.mac': { ja: 'MAC', en: 'MAC' },
  'it.ip.free': { ja: '空き', en: 'Free' },
  'it.ip.network': { ja: 'ネットワークアドレス', en: 'Network address' },
  'it.ip.broadcast': { ja: 'ブロードキャスト', en: 'Broadcast' },

  'mfg.supplier.code': { ja: 'コード', en: 'Code' },
  'mfg.supplier.contact': { ja: '担当者', en: 'Contact' },
  'mfg.supplier.email': { ja: 'メール', en: 'Email' },
  'mfg.supplier.phone': { ja: '電話', en: 'Phone' },
  'mfg.supplier.fax': { ja: 'FAX', en: 'Fax' },
  'mfg.supplier.countryCode': { ja: '国番号', en: 'Country code' },
  'mfg.supplier.telHint': { ja: 'ハイフン有無どちらでも可。国番号に合わせて自動で検証・整形します', en: 'Hyphens optional — validated and formatted automatically for the country' },
  'mfg.supplier.telInvalid': { ja: '番号が正しくありません', en: 'Invalid number' },
  'mfg.supplier.address': { ja: '住所', en: 'Address' },
  'mfg.supplier.empty': { ja: '仕入先がありません', en: 'No suppliers yet' },
  'mfg.supplier.new': { ja: '仕入先を登録', en: 'New supplier' },
  'mfg.supplier.kana': { ja: 'カナ', en: 'Kana' },
  'mfg.supplier.shortName': { ja: '略称', en: 'Short name' },
  'mfg.supplier.zip': { ja: '郵便番号', en: 'ZIP' },
  'mfg.supplier.invoiceRegNo': { ja: 'インボイス登録番号', en: 'Invoice reg. no.' },
  'mfg.supplier.paymentInfo': { ja: '支払情報（銀行口座）', en: 'Payment info (bank account)' },
  'mfg.supplier.bankName': { ja: '銀行名', en: 'Bank' },
  'mfg.supplier.branchName': { ja: '支店名', en: 'Branch' },
  'mfg.supplier.bankCode': { ja: '銀行コード', en: 'Bank code' },
  'mfg.supplier.branchCode': { ja: '支店コード', en: 'Branch code' },
  'mfg.supplier.accountType': { ja: '口座種別', en: 'Account type' },
  'mfg.supplier.accountNo': { ja: '口座番号', en: 'Account no.' },
  'mfg.supplier.accountHolder': { ja: '口座名義', en: 'Account holder' },
  'mfg.supplier.importLegacy': { ja: 'レガシー取込', en: 'Legacy import' },
  'mfg.supplier.importing': { ja: '取込中…', en: 'Importing…' },
  'mfg.supplier.importConfirm': { ja: 'レガシー仕入先ファイル(.xlsx)を取り込みます。同じコード・名称の仕入先は上書き更新されます。よろしいですか？', en: 'Import legacy suppliers (.xlsx)? Entries with matching code/name will be updated.' },
  'mfg.supplier.importDone': { ja: '取込完了: 新規{created}件 / 更新{updated}件 / スキップ{skipped}件', en: 'Imported: {created} new / {updated} updated / {skipped} skipped' },
  // ── 仕入先 一括削除 ──
  'mfg.supplier.selectAll': { ja: 'すべて選択', en: 'Select all' },
  'mfg.supplier.selectRow': { ja: '{name} を選択', en: 'Select {name}' },
  'mfg.supplier.bulkSelected': { ja: '{count}件を選択中', en: '{count} selected' },
  'mfg.supplier.bulkClear': { ja: '選択解除', en: 'Clear' },
  'mfg.supplier.bulkDelete': { ja: '一括削除', en: 'Delete selected' },
  'mfg.supplier.bulkDeleteTitle': { ja: '選択した仕入先を削除', en: 'Delete selected suppliers' },
  'mfg.supplier.bulkDeleteConfirm': { ja: '選択中の{count}件の仕入先を削除します。よろしいですか？', en: 'Delete the {count} selected suppliers?' },
  'mfg.supplier.bulkDeleteHint': { ja: '品目で使用中の仕入先は自動的にスキップされます（削除されません）。この操作は元に戻せません。', en: 'Suppliers in use by items will be automatically skipped. This action cannot be undone.' },
  'mfg.supplier.bulkDeleteConfirmBtn': { ja: '削除する', en: 'Delete' },
  'mfg.supplier.bulkDeleteDone': { ja: '削除完了: {deleted}件を削除 / {skipped}件をスキップ', en: 'Deleted {deleted}, skipped {skipped}' },
  'mfg.supplier.bulkDeleteAll': { ja: '{deleted}件の仕入先を削除しました', en: 'Deleted {deleted} suppliers' },
  'mfg.supplier.bulkDeleteSkippedHint': { ja: '使用中のためスキップ: {names}', en: 'Skipped (in use): {names}' },

  // ── 製造管理 — locations ──
  'mfg.location.code': { ja: 'コード', en: 'Code' },
  'mfg.location.name': { ja: '名称', en: 'Name' },
  'mfg.location.warehouse': { ja: '倉庫', en: 'Warehouse' },
  'mfg.location.parent': { ja: '所属倉庫', en: 'Warehouse' },
  'mfg.location.parentNone': { ja: '（なし）', en: '(None)' },
  'mfg.location.parentHint': { ja: '種別「倉庫」のロケーションを先に登録してください', en: 'Create a location of kind "Warehouse" first' },
  'mfg.location.kind': { ja: '種別', en: 'Kind' },
  'mfg.location.empty': { ja: 'ロケーションがありません', en: 'No locations yet' },
  'mfg.location.new': { ja: 'ロケーションを登録', en: 'New location' },
  'mfg.location.kind.warehouse': { ja: '倉庫', en: 'Warehouse' },
  'mfg.location.kind.zone': { ja: 'ゾーン', en: 'Zone' },
  'mfg.location.kind.bin': { ja: 'ビン', en: 'Bin' },
  'mfg.location.kind.shelf': { ja: '棚', en: 'Shelf' },

  // ── 製造管理 — moves ──
  'mfg.moves.when': { ja: '日時', en: 'When' },
  'mfg.moves.item': { ja: '品目', en: 'Item' },
  'mfg.moves.type': { ja: '種別', en: 'Type' },
  'mfg.moves.qty': { ja: '数量', en: 'Qty' },
  'mfg.moves.from': { ja: '移動元', en: 'From' },
  'mfg.moves.to': { ja: '移動先', en: 'To' },
  'mfg.moves.by': { ja: '担当', en: 'By' },
  'mfg.moves.reason': { ja: '理由', en: 'Reason' },
  'mfg.moves.empty': { ja: '履歴がありません', en: 'No history yet' },
  'mfg.move.receipt': { ja: '入荷', en: 'Receipt' },
  'mfg.move.issue': { ja: '出庫', en: 'Issue' },
  'mfg.move.adjust': { ja: '調整', en: 'Adjust' },
  'mfg.move.transfer': { ja: '移動', en: 'Transfer' },
  'mfg.move.return': { ja: '返却', en: 'Return' },
  'mfg.move.transfer_out': { ja: '移動(出)', en: 'Transfer out' },
  'mfg.move.transfer_in': { ja: '移動(入)', en: 'Transfer in' },
  'mfg.transfer.btn': { ja: '部門間移動', en: 'Transfer' },
  'mfg.transfer.title': { ja: '部門間在庫移動', en: 'Inter-department transfer' },
  'mfg.transfer.item': { ja: '品目', en: 'Item' },
  'mfg.transfer.selectItem': { ja: '品目を選択してください', en: 'Select an item' },
  'mfg.transfer.from': { ja: '移動元部門', en: 'From department' },
  'mfg.transfer.to': { ja: '移動先部門', en: 'To department' },
  'mfg.transfer.qty': { ja: '数量', en: 'Quantity' },
  'mfg.transfer.reason': { ja: '理由', en: 'Reason' },
  'mfg.transfer.submit': { ja: '移動する', en: 'Transfer' },
  'mfg.transfer.success': { ja: '部門間移動が完了しました', en: 'Transfer complete' },
  'mfg.transfer.sameDeptError': { ja: '異なる部門を選択してください', en: 'Select different departments' },

  // ── 製造管理 — scan ──
  'mfg.scan.title': { ja: 'バーコードスキャン', en: 'Barcode Scan' },
  'mfg.scan.start': { ja: 'スキャン開始', en: 'Start scan' },
  'mfg.scan.stop': { ja: '停止', en: 'Stop' },
  'mfg.scan.hint': { ja: 'カメラにバーコード／QRをかざしてください', en: 'Point the camera at a barcode / QR' },
  'mfg.scan.notFound': { ja: '該当する品目・ロットが見つかりません', en: 'No matching item or lot found' },
  'mfg.scan.manual': { ja: 'コードを手入力', en: 'Enter code manually' },
  'mfg.scan.result.item': { ja: '品目が見つかりました', en: 'Item found' },
  'mfg.scan.result.lot': { ja: 'ロットが見つかりました', en: 'Lot found' },

  // ── 製造 Phase 2: 設備・工具 / メンテナンス / 保護具 ──
  'mfg.nav.equipment': { ja: '設備・工具', en: 'Equipment' },
  'mfg.nav.maintenance': { ja: 'メンテナンス', en: 'Maintenance' },
  'mfg.nav.ppe': { ja: '保護具', en: 'PPE' },
  'mfg.common.new': { ja: '新規', en: 'New' },
  'mfg.common.save': { ja: '保存', en: 'Save' },
  'mfg.common.saving': { ja: '保存中…', en: 'Saving…' },
  'mfg.common.cancel': { ja: 'キャンセル', en: 'Cancel' },
  'mfg.common.edit': { ja: '編集', en: 'Edit' },
  'mfg.common.delete': { ja: '削除', en: 'Delete' },
  'mfg.common.search': { ja: '検索', en: 'Search' },
  'mfg.common.all': { ja: 'すべて', en: 'All' },
  'mfg.common.none': { ja: 'なし', en: 'None' },
  'mfg.common.saved': { ja: '保存しました', en: 'Saved' },
  'mfg.common.deleted': { ja: '削除しました', en: 'Deleted' },
  'mfg.common.error': { ja: 'エラーが発生しました', en: 'Something went wrong' },
  'mfg.common.notes': { ja: '備考', en: 'Notes' },
  'mfg.common.status': { ja: '状態', en: 'Status' },
  // equipment
  'mfg.eq.title': { ja: '設備・工具', en: 'Equipment & Tools' },
  'mfg.eq.assetNo': { ja: '管理番号', en: 'Asset No.' },
  'mfg.eq.name': { ja: '名称', en: 'Name' },
  'mfg.eq.kind': { ja: '種別', en: 'Kind' },
  'mfg.eq.maker': { ja: 'メーカー', en: 'Maker' },
  'mfg.eq.model': { ja: '型式', en: 'Model' },
  'mfg.eq.serial': { ja: '製造番号', en: 'Serial No.' },
  'mfg.eq.location': { ja: '設置場所', en: 'Location' },
  'mfg.eq.installedOn': { ja: '導入日', en: 'Installed on' },
  'mfg.eq.owner': { ja: '担当者', en: 'Owner' },
  'mfg.dept.unassigned': { ja: '製造部門が未割当', en: 'No production department assigned' },
  'mfg.dept.unassignedHint': {
    ja: '管理者に「ユーザー管理」で所属製造部門を設定してもらってください。',
    en: 'Ask an administrator to set your production department in User management.',
  },
  'mfg.eq.inspection.title': { ja: '点検・校正', en: 'Inspection & calibration' },
  'mfg.eq.inspection.label': { ja: '点検', en: 'Inspection' },
  'mfg.eq.inspection.interval': { ja: '点検間隔（月）', en: 'Interval (months)' },
  'mfg.eq.inspection.last': { ja: '前回点検日', en: 'Last done' },
  'mfg.eq.inspection.next': { ja: '次回点検日', en: 'Next due' },
  'mfg.eq.inspection.nextHint': { ja: '空欄なら「前回点検日＋点検間隔（月）」で計算します', en: 'Leave blank to compute from last done + interval (months)' },
  'mfg.eq.inspection.owner': { ja: '点検担当者', en: 'Responsible' },
  'mfg.eq.inspection.recordDone': { ja: '実施を記録', en: 'Record as done' },
  'mfg.eq.calibration.label': { ja: '校正', en: 'Calibration' },
  'mfg.eq.calibration.required': { ja: '校正が必要な計測器', en: 'Needs calibration' },
  'mfg.eq.calibration.interval': { ja: '校正間隔（月）', en: 'Calibration interval (months)' },
  'mfg.eq.calibration.last': { ja: '前回校正日', en: 'Last calibrated' },
  'mfg.eq.calibration.next': { ja: '次回校正日', en: 'Calibration due' },
  'mfg.eq.calibration.owner': { ja: '校正担当者', en: 'Calibration responsible' },
  'mfg.eq.badge.overdue': { ja: '期限超過', en: 'Overdue' },
  'mfg.eq.badge.inspectionOverdue': { ja: '点検期限超過', en: 'Inspection overdue' },
  'mfg.eq.badge.calibrationOverdue': { ja: '校正期限超過', en: 'Calibration overdue' },
  'mfg.eq.badge.dueSoon': { ja: '期限間近', en: 'Due soon' },
  'mfg.eq.due.overdue': { ja: '期限超過のみ', en: 'Overdue only' },
  'mfg.eq.due.soon': { ja: '期限間近のみ', en: 'Due soon only' },
  'mfg.eq.new': { ja: '設備を登録', en: 'Add equipment' },
  'mfg.eq.edit': { ja: '設備を編集', en: 'Edit equipment' },
  'mfg.eq.empty': { ja: '設備が登録されていません', en: 'No equipment yet' },
  'mfg.eq.label': { ja: 'ラベル印刷', en: 'Print label' },
  'mfg.eq.reportBreakdown': { ja: '故障報告', en: 'Report breakdown' },
  'mfg.eq.changeStatus': { ja: '状態変更', en: 'Change status' },
  'mfg.eq.kind.machine': { ja: '設備', en: 'Machine' },
  'mfg.eq.kind.tool': { ja: '工具', en: 'Tool' },
  'mfg.eq.kind.jig': { ja: '治具', en: 'Jig' },
  'mfg.eq.kind.gauge': { ja: '測定器', en: 'Gauge' },
  'mfg.eq.status.storage': { ja: '保管中（在庫）', en: 'In storage' },
  'mfg.eq.status.operational': { ja: '稼働中', en: 'Operational' },
  'mfg.eq.status.maintenance': { ja: 'メンテ中', en: 'Maintenance' },
  'mfg.eq.status.breakdown': { ja: '故障', en: 'Breakdown' },
  'mfg.eq.status.retired': { ja: '廃棄', en: 'Retired' },
  'mfg.eq.stat.operational': { ja: '稼働中', en: 'Operational' },
  'mfg.eq.stat.maintenance': { ja: 'メンテ中', en: 'In maintenance' },
  'mfg.eq.stat.breakdown': { ja: '故障', en: 'Breakdown' },
  'mfg.eq.stat.overdue': { ja: '点検期限超過', en: 'Overdue checks' },
  'mfg.eq.stat.openRepairs': { ja: '未対応の修理', en: 'Open repairs' },
  // maintenance
  'mfg.maint.title': { ja: 'メンテナンス', en: 'Maintenance' },
  'mfg.maint.schedules': { ja: '予防保全スケジュール', en: 'Preventive schedules' },
  'mfg.maint.logs': { ja: 'メンテナンス記録', en: 'Maintenance log' },
  'mfg.maint.dueNow': { ja: '点検が必要な設備', en: 'Maintenance due' },
  'mfg.maint.newSchedule': { ja: 'スケジュールを追加', en: 'Add schedule' },
  'mfg.maint.editSchedule': { ja: 'スケジュールを編集', en: 'Edit schedule' },
  'mfg.maint.scheduleTitle': { ja: '点検名', en: 'Schedule title' },
  'mfg.maint.intervalType': { ja: '周期タイプ', en: 'Interval type' },
  'mfg.maint.intervalDays': { ja: '周期（日数）', en: 'Every N days' },
  'mfg.maint.fixedDates': { ja: '指定日（カンマ区切り）', en: 'Fixed dates (comma-separated)' },
  'mfg.maint.intervalType.days': { ja: '日数周期', en: 'Every N days' },
  'mfg.maint.intervalType.date': { ja: '指定日', en: 'Fixed dates' },
  'mfg.maint.checklist': { ja: 'チェック項目（改行区切り）', en: 'Checklist (one per line)' },
  'mfg.maint.assignee': { ja: '担当者', en: 'Assignee' },
  'mfg.maint.lastDone': { ja: '前回実施日', en: 'Last done' },
  'mfg.maint.nextDue': { ja: '次回予定', en: 'Next due' },
  'mfg.maint.active': { ja: '有効', en: 'Active' },
  'mfg.maint.complete': { ja: '点検実施', en: 'Record check' },
  'mfg.maint.completeTitle': { ja: '点検を記録', en: 'Record inspection' },
  'mfg.maint.performedOn': { ja: '実施日', en: 'Performed on' },
  'mfg.maint.performedBy': { ja: '実施者', en: 'Performed by' },
  'mfg.maint.newCorrective': { ja: '修理記録を追加', en: 'Add repair log' },
  'mfg.maint.corrTitle': { ja: '事後保全（修理）記録', en: 'Corrective (repair) log' },
  'mfg.maint.equipment': { ja: '設備', en: 'Equipment' },
  'mfg.maint.reportedOn': { ja: '発生日', en: 'Reported on' },
  'mfg.maint.symptom': { ja: '症状', en: 'Symptom' },
  'mfg.maint.action': { ja: '対応内容', en: 'Action taken' },
  'mfg.maint.parts': { ja: '交換部品', en: 'Parts' },
  'mfg.maint.downtime': { ja: 'ダウンタイム（時間）', en: 'Downtime (hrs)' },
  'mfg.maint.cost': { ja: '費用', en: 'Cost' },
  'mfg.maint.setBreakdown': { ja: '設備を故障に設定', en: 'Mark equipment as breakdown' },
  'mfg.maint.close': { ja: '完了にする', en: 'Mark resolved' },
  'mfg.maint.type': { ja: '種別', en: 'Type' },
  'mfg.maint.type.preventive': { ja: '予防保全', en: 'Preventive' },
  'mfg.maint.type.corrective': { ja: '事後保全', en: 'Corrective' },
  'mfg.maint.noSchedules': { ja: 'スケジュールがありません', en: 'No schedules' },
  'mfg.maint.noLogs': { ja: '記録がありません', en: 'No logs yet' },
  'mfg.maint.noDue': { ja: '点検期限の設備はありません', en: 'Nothing due' },
  'mfg.maint.statusOpen': { ja: '対応中', en: 'Open' },
  'mfg.maint.statusClosed': { ja: '完了', en: 'Closed' },
  // PPE
  'mfg.ppe.title': { ja: '保護具', en: 'PPE' },
  'mfg.ppe.no': { ja: '管理番号', en: 'No.' },
  'mfg.ppe.name': { ja: '名称', en: 'Name' },
  'mfg.ppe.category': { ja: '区分', en: 'Category' },
  'mfg.ppe.assignedTo': { ja: '使用者', en: 'Assigned to' },
  'mfg.ppe.quantity': { ja: '数量', en: 'Qty' },
  'mfg.ppe.interval': { ja: '点検周期（日数）', en: 'Inspection cycle (days)' },
  'mfg.ppe.lastInspected': { ja: '前回点検日', en: 'Last inspected' },
  'mfg.ppe.nextInspection': { ja: '次回点検', en: 'Next inspection' },
  'mfg.ppe.new': { ja: '保護具を登録', en: 'Add PPE' },
  'mfg.ppe.edit': { ja: '保護具を編集', en: 'Edit PPE' },
  'mfg.ppe.empty': { ja: '保護具が登録されていません', en: 'No PPE yet' },
  'mfg.ppe.inspect': { ja: '点検実施', en: 'Inspect' },
  'mfg.ppe.inspectTitle': { ja: '点検を記録', en: 'Record inspection' },
  'mfg.ppe.result': { ja: '結果', en: 'Result' },
  'mfg.ppe.result.ok': { ja: '良好', en: 'OK' },
  'mfg.ppe.result.ng': { ja: '要交換', en: 'NG' },
  'mfg.ppe.inspector': { ja: '点検者', en: 'Inspector' },
  'mfg.ppe.status.ok': { ja: '良好', en: 'OK' },
  'mfg.ppe.status.attention': { ja: '要確認', en: 'Attention' },
  'mfg.ppe.status.retired': { ja: '廃棄', en: 'Retired' },
  'mfg.ppe.stat.total': { ja: '登録数', en: 'Total' },
  'mfg.ppe.stat.overdue': { ja: '点検期限超過', en: 'Overdue' },
  'mfg.ppe.stat.dueSoon': { ja: '近日点検', en: 'Due soon' },
  'mfg.alert.overdue': { ja: '期限超過', en: 'Overdue' },
  'mfg.alert.dueSoon': { ja: '近日予定', en: 'Due soon' },

  // ── 製造ダッシュボード ──
  'mfg.nav.dashboard': { ja: 'ダッシュボード', en: 'Dashboard' },
  'mfg.nav.inventory2': { ja: '在庫一覧', en: 'Inventory' },
  'mfg.nav.mfgNo': { ja: '製造番号', en: 'Mfg No.' },
  'mfg.mfgno.title': { ja: '製造番号管理', en: 'Manufacturing Numbers' },
  'mfg.mfgno.autoDesc': { ja: '自動発番（YY＋連番＋月記号）', en: 'Auto (YY + serial + month)' },
  'mfg.mfgno.manualDesc': { ja: '手動入力', en: 'Manual entry' },
  'mfg.mfgno.new': { ja: '新規発番', en: 'Issue No.' },
  'mfg.mfgno.newManual': { ja: '新規登録', en: 'Add No.' },
  'mfg.mfgno.next': { ja: '次の製造番号', en: 'Next number' },
  'mfg.mfgno.startNo': { ja: '開始番号（連番）', en: 'Start serial' },
  'mfg.mfgno.saveSeq': { ja: '採番設定を保存', en: 'Save numbering' },
  'mfg.mfgno.seqHint': { ja: '※ 連番は自動リセットされません。年初などに開始番号を変更してください（例: 1）。月記号は当月から自動付与（A=1月…L=12月）。', en: 'Serial does not auto-reset. Change the start serial (e.g. 1) at year start. Month letter is auto from the current month (A=Jan … L=Dec).' },
  'mfg.mfgno.colNo': { ja: '製造番号', en: 'Mfg No.' },
  'mfg.mfgno.colItem': { ja: '品目', en: 'Item' },
  'mfg.mfgno.colKind': { ja: '区分', en: 'Type' },
  'mfg.mfgno.kindAuto': { ja: '自動', en: 'Auto' },
  'mfg.mfgno.kindManual': { ja: '手動', en: 'Manual' },
  'mfg.mfgno.colDate': { ja: '登録日', en: 'Date' },
  'mfg.mfgno.empty': { ja: '製造番号がありません', en: 'No manufacturing numbers yet' },
  'mfg.mfgno.pickDept': { ja: '部門を選択すると製造番号を管理できます。', en: 'Select a department to manage manufacturing numbers.' },
  'mfg.mfgno.autoIssue': { ja: '自動発番', en: 'Auto-issued' },
  'mfg.mfgno.noPlaceholder': { ja: '製造番号を入力（手動）', en: 'Enter manufacturing number' },
  'mfg.mfgno.itemNone': { ja: '品目なし', en: 'No item' },
  'mfg.mfgno.editTitle': { ja: '製造番号を編集', en: 'Edit manufacturing number' },
  'mfg.wo.mfgNo': { ja: '製造番号', en: 'Mfg No.' },
  'mfg.wo.mfgNoNone': { ja: '紐付けなし', en: 'None' },
  'mfg.dept.all': { ja: '全部門', en: 'All departments' },
  'mfg.dept.allBanner': { ja: '全部門（統合ビュー）', en: 'All departments (consolidated)' },
  'mfg.dept.allHint': { ja: '全部門の在庫を統合表示', en: 'Consolidated view across all departments' },
  'mfg.dept.select': { ja: '部門を選択', en: 'Select department' },
  'mfg.dept.switch': { ja: '部門を切り替え', en: 'Switch department' },
  'mfg.dept.pickTitle': { ja: '製造部門を選択してください', en: 'Choose a manufacturing department' },
  'mfg.dept.pickSubtitle': { ja: '作業する部門を選ぶと、その部門の在庫・製造オーダー・設備が表示されます', en: 'Pick the department you work in — inventory, work orders and equipment will be scoped to it' },
  'mfg.dash.title': { ja: '製造ダッシュボード', en: 'Manufacturing Dashboard' },
  'mfg.dash.subtitle': { ja: '在庫の状態をひと目で確認', en: 'Your inventory at a glance' },
  'mfg.dash.stat.items': { ja: '品目数', en: 'Items' },
  'mfg.dash.stat.value': { ja: '在庫評価額', en: 'Stock value' },
  'mfg.dash.stat.low': { ja: '発注点割れ', en: 'Low stock' },
  'mfg.dash.stat.expiring': { ja: '期限間近', en: 'Expiring soon' },
  'mfg.dash.stat.overstock': { ja: '過剰在庫', en: 'Overstock' },
  'mfg.dash.valueByCategory': { ja: '在庫評価額（カテゴリ別）', en: 'Stock value by category' },
  'mfg.dash.totalValue': { ja: '合計', en: 'Total' },
  'mfg.dash.noValue': { ja: '在庫評価額のデータがありません', en: 'No stock value data' },
  'mfg.dash.lowStock': { ja: '発注点割れの品目', en: 'Low-stock items' },
  'mfg.dash.expiring': { ja: '期限間近のロット', en: 'Expiring lots' },
  'mfg.dash.recentMoves': { ja: '最近の在庫移動', en: 'Recent stock movements' },
  'mfg.dash.viewAll': { ja: 'すべて見る', en: 'View all' },
  'mfg.dash.noLow': { ja: '発注点を割っている品目はありません', en: 'No items below reorder point' },
  'mfg.dash.noExpiring': { ja: '期限間近のロットはありません', en: 'No lots expiring soon' },
  'mfg.dash.noMoves': { ja: '在庫移動の履歴がありません', en: 'No stock movements yet' },
  'mfg.dash.reorderAt': { ja: '発注点', en: 'Reorder at' },
  'mfg.dash.daysLeft': { ja: '日', en: 'd' },
  'mfg.dash.expired': { ja: '期限切れ', en: 'Expired' },
  'mfg.dash.itemsCount': { ja: '品目', en: 'items' },
  'mfg.dash.quickStart.title': { ja: 'クイックスタート — 部品の登録から入荷まで', en: 'Quick start — register & receive parts' },
  'mfg.dash.quickStart.subtitle': { ja: '部品（品目）は「在庫一覧」で管理します。次の3ステップで登録できます。', en: 'Parts (items) live in 在庫一覧. Register them in 3 steps.' },
  'mfg.dash.quickStart.s1Title': { ja: '① 在庫一覧を開く', en: 'Open 在庫一覧' },
  'mfg.dash.quickStart.s1Desc': { ja: 'すべての部品（品目マスター）はここで一覧・検索できます。', en: 'All parts (item master) are listed and searchable here.' },
  'mfg.dash.quickStart.s2Title': { ja: '② 品目を新規登録', en: 'Add a new item' },
  'mfg.dash.quickStart.s2Desc': { ja: '「新規」ボタンで品番・名称・単位などを登録します。', en: 'Use the 新規 button to add SKU, name, unit, etc.' },
  'mfg.dash.quickStart.s3Title': { ja: '③ 入荷して在庫を計上', en: 'Receive into stock' },
  'mfg.dash.quickStart.s3Desc': { ja: '品目を選び「入荷」でロット・数量・置き場所を記録します。', en: 'Open the item and use 入荷 to log lot, qty and location.' },
  'mfg.dash.quickStart.cta': { ja: '品目を新規登録', en: 'Register a new item' },
  'mfg.dash.quickStart.openInventory': { ja: '在庫一覧を開く', en: 'Open inventory' },
  'mfg.dash.quickStart.hint': { ja: '※ 置き場所（ロケーション）の登録は任意です', en: '* Locations are optional' },


  // ── 製造 Phase 3: 部品表(BOM) / 製造オーダー ──
  'mfg.nav.bom': { ja: '部品表', en: 'BOM' },
  'mfg.nav.bomList': { ja: '部品表一覧', en: 'BOM List' },
  'mfg.nav.labor': { ja: '工数レポート', en: 'Labor Report' },
  'mfg.bomList.standardHours': { ja: '標準工数', en: 'Std hrs' },
  'mfg.wo.laborResult': { ja: '工数実績', en: 'Labor result' },
  'mfg.wo.actualHours': { ja: '実績工数', en: 'Actual hours' },
  'mfg.wo.laborEfficiency': { ja: '工数効率', en: 'Labor efficiency' },
  'mfg.wo.actualCost': { ja: '実績労務費', en: 'Actual labor cost' },
  'mfg.wo.standardCost': { ja: '標準労務費', en: 'Standard labor cost' },
  'mfg.wo.costVariance': { ja: '差異', en: 'Variance' },
  'mfg.labor.title': { ja: '工数レポート', en: 'Labor Report' },
  'mfg.labor.desc': { ja: '標準工数（理論値）とキオスクの実績工数を比較します。効率 = 標準 ÷ 実績。', en: 'Compares standard (theoretical) hours with actual hours from the kiosk. Efficiency = standard ÷ actual.' },
  'mfg.labor.byItem': { ja: '品目別', en: 'By item' },
  'mfg.labor.byStation': { ja: '作業区別', en: 'By work center' },
  'mfg.labor.standard': { ja: '標準工数', en: 'Standard' },
  'mfg.labor.actual': { ja: '平均実績', en: 'Avg actual' },
  'mfg.labor.avgActual': { ja: '平均実績工数', en: 'Avg actual hrs' },
  'mfg.labor.efficiency': { ja: '効率', en: 'Efficiency' },
  'mfg.labor.samples': { ja: '完了数', en: 'Orders' },
  'mfg.labor.stdCost': { ja: '標準労務費', en: 'Std cost' },
  'mfg.labor.actualCost': { ja: '実績労務費', en: 'Actual cost' },
  'mfg.labor.costVariance': { ja: '差異', en: 'Variance' },
  'mfg.labor.empty': { ja: '完了した製造オーダーの実績がまだありません。', en: 'No completed work-order actuals yet.' },
  'mfg.bomList.title': { ja: '部品表一覧', en: 'BOM List' },
  'mfg.bomList.desc': { ja: '部品表（BOM）が登録されている品目の一覧です。行をクリックすると編集できます。', en: 'Items that have a bill of materials. Click a row to edit its BOM.' },
  'mfg.bomList.item': { ja: '品目', en: 'Item' },
  'mfg.bomList.components': { ja: '構成部品数', en: 'Components' },
  'mfg.bomList.componentsUnit': { ja: '点', en: 'items' },
  'mfg.bomList.station': { ja: '製造ステーション', en: 'Station' },
  'mfg.bomList.stationNone': { ja: '未指定', en: 'Not set' },
  'mfg.bomList.updated': { ja: '更新日', en: 'Updated' },
  'mfg.bomList.count': { ja: '{n} 件', en: '{n} items' },
  'mfg.bomList.empty': { ja: '部品表が登録されている品目はまだありません。', en: 'No items have a BOM yet.' },
  'mfg.bomList.delete': { ja: '部品表を削除', en: 'Delete BOM' },
  'mfg.bomList.confirmDelete': { ja: '「{name}」の部品表を削除します。よろしいですか？（品目自体は残ります）', en: 'Delete the BOM for “{name}”? (The item itself is kept.)' },
  'mfg.bomList.deleted': { ja: '部品表を削除しました', en: 'BOM deleted' },
  'mfg.bomList.replaceMain': { ja: '主部品を変更', en: 'Replace main part' },
  'mfg.bomList.replaceConfirm': { ja: '変更する', en: 'Replace' },
  'mfg.bomList.currentMain': { ja: '現在の主部品', en: 'Current main part' },
  'mfg.bomList.newMain': { ja: '新しい主部品', en: 'New main part' },
  'mfg.bomList.pickNewItem': { ja: '変更先の品目を選択してください', en: 'Please select the new item' },
  'mfg.bomList.moved': { ja: '主部品を変更しました', en: 'Main part replaced' },
  'mfg.bomList.replaceHint': { ja: 'この部品表の構成部品と製造ステーションが新しい主部品へ移動し、元の品目は部品表なしになります。変更先に既に部品表がある場合は変更できません。', en: 'The components and station move to the new main part; the original item is left with no BOM. Blocked if the target already has a BOM.' },
  'mfg.nav.workOrders': { ja: '製造オーダー', en: 'Work Orders' },
  'mfg.nav.schedule': { ja: '生産計画', en: 'Schedule' },
  'mfg.nav.analytics': { ja: '分析', en: 'Analytics' },
  'mfg.analytics.oee': { ja: 'OEE', en: 'OEE' },
  'mfg.analytics.availability': { ja: '稼働率', en: 'Availability' },
  'mfg.analytics.performance': { ja: '性能', en: 'Performance' },
  'mfg.analytics.quality': { ja: '品質', en: 'Quality' },
  'mfg.analytics.output': { ja: '生産数', en: 'Output' },
  'mfg.analytics.scrap': { ja: '不良数', en: 'Scrap' },
  'mfg.analytics.scrapRate': { ja: '不良率', en: 'Scrap rate' },
  'mfg.analytics.onTime': { ja: '納期遵守率', en: 'On-time' },
  'mfg.analytics.completed': { ja: '完了数', en: 'Completed' },
  'mfg.analytics.trend': { ja: '生産・OEE 推移', en: 'Output & OEE trend' },
  'mfg.analytics.scrapByReason': { ja: '不良要因', en: 'Scrap by reason' },
  'mfg.analytics.noScrap': { ja: '不良の記録はありません', en: 'No scrap recorded' },
  'mfg.analytics.byDept': { ja: '部門別比較', en: 'By department' },
  'mfg.analytics.dept': { ja: '部門', en: 'Dept' },
  'mfg.analytics.topScrap': { ja: '不良の多い品目', en: 'Top scrap items' },
  'mfg.analytics.recent': { ja: '最近の完了オーダー', en: 'Recent completions' },
  'mfg.analytics.empty': { ja: 'この期間に完了したオーダーはありません', en: 'No completed orders in this period' },
  'mfg.analytics.range.week': { ja: '今週', en: 'This week' },
  'mfg.analytics.range.month': { ja: '今月', en: 'This month' },
  'mfg.analytics.range.d90': { ja: '過去90日', en: 'Last 90 days' },
  'mfg.analytics.range.custom': { ja: 'カスタム', en: 'Custom' },
  'mfg.scrapReason.dimension': { ja: '寸法不良', en: 'Dimension' },
  'mfg.scrapReason.scratch': { ja: 'キズ・打痕', en: 'Scratch/dent' },
  'mfg.scrapReason.material': { ja: '材料不良', en: 'Material' },
  'mfg.scrapReason.equipment': { ja: '設備不良', en: 'Equipment' },
  'mfg.scrapReason.operation': { ja: '作業ミス', en: 'Operation' },
  'mfg.scrapReason.other': { ja: 'その他', en: 'Other' },
  'mfg.nav.kiosk': { ja: 'キオスク', en: 'Kiosk' },
  'mfg.nav.workCenters': { ja: '作業区', en: 'Work Centers' },
  'mfg.kiosk.title': { ja: '製造キオスク', en: 'Production Kiosk' },
  'mfg.kiosk.pickDept': { ja: '部門を選択してください', en: 'Select a department' },
  'mfg.kiosk.refresh': { ja: '更新', en: 'Refresh' },
  'mfg.kiosk.scan': { ja: 'スキャン', en: 'Scan' },
  'mfg.kiosk.changeDept': { ja: '部門変更', en: 'Change dept' },
  'mfg.kiosk.exit': { ja: '終了', en: 'Exit' },
  'mfg.kiosk.empty': { ja: '対応が必要な製造オーダーはありません', en: 'No work orders need action' },
  'mfg.kiosk.shortage': { ja: '部品不足', en: 'Shortage' },
  'mfg.kiosk.shortageWarn': { ja: '部品在庫が不足しています。完了できない場合があります。', en: 'Component stock is short — completion may fail.' },
  'mfg.kiosk.start': { ja: '開始', en: 'Start' },
  'mfg.kiosk.complete': { ja: '完了', en: 'Complete' },
  'mfg.kiosk.hold': { ja: '保留', en: 'Hold' },
  'mfg.kiosk.resume': { ja: '再開', en: 'Resume' },
  'mfg.kiosk.completeConfirm': { ja: '完了すると部品を消費し、完成品を在庫に登録します。よろしいですか？', en: 'Completing consumes components and books finished goods. Proceed?' },
  'mfg.kiosk.completeDo': { ja: '完了する', en: 'Complete' },
  'mfg.kiosk.doneStart': { ja: '製造を開始しました', en: 'Work order started' },
  'mfg.kiosk.doneComplete': { ja: '製造を完了しました', en: 'Work order completed' },
  'mfg.kiosk.doneHold': { ja: '保留にしました', en: 'Put on hold' },
  'mfg.kiosk.doneResume': { ja: '再開しました', en: 'Resumed' },
  'mfg.kiosk.heldReason': { ja: 'キオスクから保留', en: 'Held from kiosk' },
  'mfg.kiosk.scanTitle': { ja: '製造番号をスキャン', en: 'Scan work order' },
  'mfg.kiosk.scanPlaceholder': { ja: '製造番号 / WO番号', en: 'Mfg no. / WO no.' },
  'mfg.kiosk.scanGo': { ja: '検索', en: 'Find' },
  'mfg.kiosk.scanNotFound': { ja: '該当する製造オーダーが見つかりません', en: 'No matching work order found' },
  'mfg.kiosk.exitConfirmTitle': { ja: 'キオスクを終了しますか？', en: 'Exit the kiosk?' },
  'mfg.kiosk.exitConfirm': { ja: '製造管理のメイン画面に戻ります。', en: 'You will return to the main Manufacturing screen.' },
  'mfg.kiosk.changeConfirmTitle': { ja: '部門を変更しますか？', en: 'Change department?' },
  'mfg.kiosk.changeConfirm': { ja: '別の部門を選び直します。', en: 'You will pick a different department.' },
  'mfg.kiosk.confirmYes': { ja: 'はい', en: 'Yes' },
  'mfg.sched.title': { ja: '生産計画', en: 'Production Schedule' },
  'mfg.sched.desc': { ja: '作業区ごとに製造オーダーを配置。バーをクリックで詳細。', en: 'Work orders laid out by work center. Click a bar for details.' },
  'mfg.sched.workCenter': { ja: '作業区', en: 'Work Center' },
  'mfg.sched.unassigned': { ja: '未割当', en: 'Unassigned' },
  'mfg.sched.start': { ja: '開始予定', en: 'Start' },
  'mfg.sched.end': { ja: '完了予定', en: 'End' },
  'mfg.sched.autoHint': { ja: '空欄の場合、納期と作業区のリードタイムから自動計算されます。', en: 'If left blank, auto-computed from the due date and the work center lead time.' },
  'mfg.sched.empty': { ja: 'スケジュール済みの製造オーダーはありません（納期または開始/完了予定を設定してください）。', en: 'No scheduled work orders (set a due date or start/end).' },
  'mfg.sched.noWorkCenters': { ja: '作業区が未登録です。マスター管理 → 作業区 で追加してください。', en: 'No work centers yet. Add them under Master Data → Work Centers.' },
  'mfg.wc.title': { ja: '作業区', en: 'Work Centers' },
  'mfg.wc.desc': { ja: '生産計画のレーン（工程・設備）を部門ごとに管理します。', en: 'Production lanes (processes/resources) per department, used by the schedule.' },
  'mfg.wc.new': { ja: '作業区を追加', en: 'New Work Center' },
  'mfg.wc.code': { ja: 'コード', en: 'Code' },
  'mfg.wc.name': { ja: '名称', en: 'Name' },
  'mfg.wc.lead': { ja: 'リードタイム', en: 'Lead time' },
  'mfg.wc.days': { ja: '日', en: 'd' },
  'mfg.wc.order': { ja: '並び順', en: 'Order' },
  'mfg.wc.activeLabel': { ja: '有効', en: 'Active' },
  'mfg.wc.inactive': { ja: '無効', en: 'Inactive' },
  'mfg.wc.empty': { ja: '作業区が登録されていません。', en: 'No work centers yet.' },
  'mfg.wc.operators': { ja: '担当者', en: 'Operators' },
  'mfg.wc.operatorsSearch': { ja: '社員を検索…', en: 'Search employees…' },
  'mfg.wc.operatorsEmpty': { ja: '該当する社員がいません', en: 'No matching employees' },
  'mfg.wc.avgActual': { ja: '平均実績工数', en: 'Avg actual hrs' },
  'mfg.wc.hourlyRate': { ja: '時間単価', en: 'Hourly rate' },
  'mfg.bom.title': { ja: '部品表 (BOM)', en: 'Bill of Materials' },
  'mfg.bom.selectItem': { ja: '製品・品目を選択', en: 'Select an item' },
  'mfg.bom.components': { ja: '構成部品', en: 'Components' },
  'mfg.bom.component': { ja: '構成部品', en: 'Component' },
  'mfg.bom.qtyPer': { ja: '員数（1個あたり）', en: 'Qty per unit' },
  'mfg.bom.uomRegistered': { ja: '単位は品目の登録単位です', en: 'Unit is the item’s registered unit' },
  'mfg.bom.dupComponent': { ja: 'この部品は既に構成部品に追加されています', en: 'This part is already in the components list' },
  'mfg.bom.unsavedTitle': { ja: '未保存の変更があります', en: 'Unsaved changes' },
  'mfg.bom.unsavedDesc': { ja: 'このページを離れると、保存していない構成部品の変更は失われます。移動してよろしいですか？', en: 'If you leave this page, unsaved BOM component changes will be lost. Continue?' },
  'mfg.bom.leaveDiscard': { ja: '破棄して移動', en: 'Discard & leave' },
  'mfg.bom.stay': { ja: 'このページに残る', en: 'Stay on page' },
  'mfg.bom.addComponent': { ja: '部品を追加', en: 'Add component' },
  'mfg.bom.station': { ja: '製造ステーション（作業区）', en: 'Manufacturing station (work center)' },
  'mfg.bom.stationNone': { ja: '未指定', en: 'Not set' },
  'mfg.bom.stationHint': { ja: 'この品目の製造オーダーを作成すると、この作業区が自動で選択されます（変更可）。', en: 'New work orders for this item default to this work center (editable).' },
  'mfg.bom.standardHours': { ja: '標準工数（理論値）', en: 'Standard hours (theoretical)' },
  'mfg.bom.standardHoursHint': { ja: '計画上の標準作業時間です。実績（キオスクの記録）と比較して効率を測定できます。', en: 'Planned standard time. Compared against actuals (from the kiosk) to measure efficiency.' },
  'mfg.bom.hoursUnit': { ja: '時間', en: 'h' },
  'mfg.bom.actualAvg': { ja: '実績平均', en: 'Actual avg' },
  'mfg.bom.sampleN': { ja: '{n} 件', en: '{n} orders' },
  'mfg.bom.applyActual': { ja: '実績を反映', en: 'Use actual' },
  'mfg.bom.standardCost': { ja: '標準労務費', en: 'Standard labor cost' },
  'mfg.bom.save': { ja: '部品表を保存', en: 'Save BOM' },
  'mfg.bom.empty': { ja: '構成部品が登録されていません', en: 'No components yet' },
  'mfg.bom.explosion': { ja: '展開（多階層）', en: 'Explosion (multi-level)' },
  'mfg.bom.explodeQty': { ja: '製造数量', en: 'Build qty' },
  'mfg.bom.required': { ja: '所要量', en: 'Required' },
  'mfg.bom.onHand': { ja: '在庫', en: 'On hand' },
  'mfg.bom.shortage': { ja: '不足', en: 'Short' },
  'mfg.bom.leaves': { ja: '必要な原材料（最下層）', en: 'Raw materials (leaves)' },
  'mfg.bom.pickPrompt': { ja: '品目を選択すると部品表を編集できます', en: 'Pick an item to edit its BOM' },
  'mfg.bom.guideTitle': { ja: '使い方ガイド — 部品の探し方', en: 'Quick start — finding parts' },
  'mfg.bom.guideShow': { ja: '使い方を表示', en: 'Show guide' },
  'mfg.bom.guideHide': { ja: '閉じる', en: 'Hide' },
  'mfg.bom.guide1': { ja: '① 上の検索ボックスに「品名・SKU・型式・メーカー品番・メーカー」のいずれかを入力すると絞り込めます（例: 22pF、0805、KYOCERA、ERJ-）。', en: 'Type any of name / SKU / model / maker part no. / maker to filter (e.g. 22pF, 0805, KYOCERA, ERJ-).' },
  'mfg.bom.guide2': { ja: '② 各候補には 型式・メーカー品番・メーカー・カテゴリ が表示されるので、同名の部品（例: SMT Capacitor）も見分けられます。', en: 'Each option shows model, maker part no., maker and category so same-named parts (e.g. SMT Capacitor) are distinguishable.' },
  'mfg.bom.guide3': { ja: '③ 部品はカテゴリごとにまとまって表示されます。「全部門から検索」をオンにすると、現在の部門以外の部品も選べます。', en: 'Options are grouped by category. Turn on “Search all departments” to pick parts outside the current department.' },
  'mfg.bom.guide4': { ja: '④ 型式・品番などの情報は品目の編集画面（在庫→品目）で登録・修正できます。', en: 'Model / part no. can be edited on the item form (Inventory → item).' },
  'mfg.bom.filterPh': { ja: '追加済みの部品を絞り込み（品名・SKU・品番・メーカー・基板記号）…', en: 'Filter added components (name / SKU / part no. / maker / ref des)…' },
  'mfg.bom.filterCount': { ja: '{shown} / {total} 件を表示', en: 'Showing {shown} / {total}' },
  'mfg.bom.noFilterMatch': { ja: '絞り込みに一致する部品がありません', en: 'No components match the filter' },
  'mfg.bom.notesPh': { ja: '備考（代替品可・実装面・注意事項など）', en: 'Notes (alternates OK, mounting side, cautions…)' },
  'mfg.bom.componentsSubtotal': { ja: '部品コスト合計（製品1個あたり）', en: 'Component cost subtotal (per unit)' },
  'mfg.bom.equipment': { ja: '使用設備（機械）', en: 'Equipment / machines' },
  'mfg.bom.equipmentAdd': { ja: '設備を追加', en: 'Add equipment' },
  'mfg.bom.equipmentNoneSelected': { ja: '使用設備が選択されていません', en: 'No equipment selected' },
  'mfg.bom.equipmentSearchTitle': { ja: '設備を検索', en: 'Search equipment' },
  'mfg.bom.equipmentSearchPh': { ja: '設備名・管理番号・メーカー・型式で検索…', en: 'Search by name / asset no. / maker / model…' },
  'mfg.bom.equipmentNoMatch': { ja: '該当する設備がありません', en: 'No matching equipment' },
  'mfg.wo.equipWarnTitle': { ja: '使用設備に問題があります', en: 'Equipment issue' },
  'mfg.wo.equipWarnHint': { ja: 'この製品の部品表に登録された設備、または選択中の設備が稼働できない状態です。作成は可能ですが、設備の状態を確認してください。', en: 'A machine on this item’s BOM (or the selected equipment) is not operational. You can still create the order, but check the machine first.' },
  'mfg.eq.impact.title': { ja: '生産への影響', en: 'Production impact' },
  'mfg.eq.impact.desc': { ja: 'メンテ中・故障の設備を使用する未完了の製造オーダー', en: 'Open work orders depending on machines under maintenance / broken' },
  'mfg.eq.impact.count': { ja: '影響 {n} 件', en: '{n} affected' },
  'mfg.eq.impact.viaDirect': { ja: '直接指定', en: 'Direct' },
  'mfg.eq.impact.viaBom': { ja: '部品表', en: 'BOM' },
  'mfg.bom.equipmentHint': { ja: 'この品目の製造に使用する設備・機械です。製造オーダー作成時、使用設備が未指定なら最初の設備が自動で選択されます（変更可）。', en: 'Machines used to build this item. New work orders default to the first machine when none is chosen (editable).' },
  'mfg.bom.equipmentNone': { ja: '設備が登録されていません（設備・工具 画面で登録できます）', en: 'No equipment registered yet (add under Equipment & Tools)' },
  'mfg.bomList.equipment': { ja: '使用設備', en: 'Equipment' },
  'mfg.wo.title': { ja: '製造オーダー', en: 'Work Orders' },
  'mfg.wo.no': { ja: 'オーダーNo.', en: 'WO No.' },
  'mfg.wo.product': { ja: '製品', en: 'Product' },
  'mfg.wo.qty': { ja: '製造数量', en: 'Qty' },
  'mfg.wo.dueDate': { ja: '納期', en: 'Due date' },
  'mfg.wo.equipment': { ja: '使用設備', en: 'Equipment' },
  'mfg.wo.equipmentPick': { ja: '設備を選択', en: 'Select equipment' },
  'mfg.wo.equipmentChange': { ja: '変更', en: 'Change' },
  'mfg.wo.equipmentClear': { ja: '未指定にする', en: 'Clear' },
  'mfg.wo.equipmentNoneRegistered': { ja: '設備が登録されていません（設備・工具 画面で登録できます）', en: 'No equipment registered yet (add under Equipment & Tools)' },
  'mfg.wo.equipmentHint': { ja: '未指定の場合、部品表に登録された最初の設備が保存時に自動的に割り当てられます。', en: 'If left empty, the first machine on the BOM will be auto-assigned on save.' },
  'mfg.wo.equipmentSuggested': { ja: '部品表からの候補', en: 'Suggested from BOM' },
  'mfg.wo.equipmentFromBom': { ja: '部品表', en: 'BOM' },
  'mfg.wo.location': { ja: '完成品の入庫先', en: 'Finished-goods location' },
  'mfg.wo.new': { ja: '製造オーダーを作成', en: 'New work order' },
  'mfg.wo.edit': { ja: '製造オーダーを編集', en: 'Edit work order' },
  'mfg.wo.empty': { ja: '製造オーダーがありません', en: 'No work orders yet' },
  'mfg.wo.components': { ja: '所要部品', en: 'Components needed' },
  'mfg.wo.shortageReqs': { ja: '不足発注依頼（資材）', en: 'Shortage requests (Procurement)' },
  'mfg.wo.release': { ja: '開始', en: 'Release' },
  'mfg.wo.start': { ja: '製造開始', en: 'Start' },
  'mfg.wo.complete': { ja: '完了', en: 'Complete' },
  'mfg.wo.completeCapture': { ja: '良品数・不良数を入力', en: 'Enter good / scrap qty' },
  'mfg.wo.completeDo': { ja: '完了する', en: 'Complete' },
  'mfg.wo.planned': { ja: '計画数', en: 'Planned' },
  'mfg.wo.goodQty': { ja: '良品数', en: 'Good qty' },
  'mfg.wo.scrapQty': { ja: '不良数', en: 'Scrap qty' },
  'mfg.wo.scrapReason': { ja: '不良要因', en: 'Scrap reason' },
  'mfg.wo.scrapNotePh': { ja: '備考(任意)', en: 'Note (optional)' },
  'mfg.wo.oeeResult': { ja: 'OEE 実績', en: 'OEE result' },
  'mfg.wo.hold': { ja: '保留', en: 'Hold' },
  'mfg.wo.resume': { ja: '再開', en: 'Resume' },
  'mfg.wo.cancel': { ja: '中止', en: 'Cancel' },
  'mfg.wo.heldReason': { ja: '保留理由', en: 'Hold reason' },
  'mfg.wo.shortage': { ja: '部品不足', en: 'Shortage' },
  'mfg.wo.completeHint': { ja: '完了すると部品を消費し、完成品を在庫へ登録します', en: 'Completing consumes components and adds finished goods to stock' },
  'mfg.wo.stat.planned': { ja: '計画', en: 'Planned' },
  'mfg.wo.stat.released': { ja: '開始済', en: 'Released' },
  'mfg.wo.stat.in_progress': { ja: '製造中', en: 'In progress' },
  'mfg.wo.stat.completed': { ja: '完了', en: 'Completed' },
  'mfg.wo.stat.shortage': { ja: '部品不足', en: 'Has shortage' },
  'mfg.wo.status.planned': { ja: '計画', en: 'Planned' },
  'mfg.wo.status.released': { ja: '開始済', en: 'Released' },
  'mfg.wo.status.in_progress': { ja: '製造中', en: 'In progress' },
  'mfg.wo.status.completed': { ja: '完了', en: 'Completed' },
  'mfg.wo.status.on_hold': { ja: '保留', en: 'On hold' },
  'mfg.wo.status.cancelled': { ja: '中止', en: 'Cancelled' },
  'mfg.wo.view': { ja: '表示', en: 'View' },
  'mfg.wo.delete': { ja: '削除', en: 'Delete' },
  'mfg.wo.deleted': { ja: '製造オーダーを削除しました', en: 'Work order deleted' },
  'mfg.wo.deleteTitle': { ja: '製造オーダーを削除', en: 'Delete work order' },
  'mfg.wo.deleteConfirm': { ja: 'この製造オーダーを完全に削除します。元に戻せません。', en: 'This work order will be permanently deleted. This cannot be undone.' },
  'mfg.wo.detail': { ja: '製造オーダー詳細', en: 'Work order details' },
  'mfg.wo.overdue': { ja: '納期超過', en: 'Overdue' },
  'mfg.wo.selectProduct': { ja: '製品を選択', en: 'Select a product' },
  'mfg.wo.required': { ja: '所要量', en: 'Required' },
  'mfg.wo.onHand': { ja: '在庫', en: 'On hand' },
  'mfg.wo.issued': { ja: '払出済', en: 'Issued' },
  'mfg.wo.preview': { ja: '所要部品（直接構成）', en: 'Required components (direct)' },
  'mfg.wo.previewHint': { ja: '製品と数量を選ぶと消費する部品を確認できます', en: 'Pick a product & qty to preview the components consumed' },
  'mfg.wo.noComponents': { ja: 'この製品には部品表が登録されていません', en: 'This product has no BOM yet' },
  'mfg.wo.holdPrompt': { ja: '保留理由を入力してください', en: 'Enter a reason for holding' },
  'mfg.wo.confirmComplete': { ja: '完了すると部品を消費し、完成品を在庫へ登録します。よろしいですか？', en: 'Completing will consume components and add finished goods to stock. Proceed?' },
  'mfg.wo.confirmCancel': { ja: 'この製造オーダーを中止しますか？', en: 'Cancel this work order?' },
  'mfg.wo.noShortageReqs': { ja: '不足発注依頼はありません', en: 'No shortage requests' },
  'mfg.wo.createdBy': { ja: '作成者', en: 'Created by' },
  'mfg.wo.reqNo': { ja: '依頼No.', en: 'Request No.' },
  'mfg.wo.createdReqs': { ja: '件の不足発注依頼を作成しました', en: 'shortage request(s) created' },
  'mfg.wo.statusLabel': { ja: '状態', en: 'Status' },
  'mfg.wo.replenishTitle': { ja: '発注点を下回る部品があります', en: 'Parts will fall below their reorder point' },
  'mfg.wo.replenishHint': { ja: 'この製造オーダーの部品消費により在庫が発注点を下回ります。チェックした部品は推奨数（発注点補充数）で不足分と同じ発注依頼に追加されます。', en: 'Consuming parts for this WO drops stock below the reorder point. Checked parts are added to the same procurement request at the recommended replenishment qty.' },
  'mfg.wo.replenishConfirm': { ja: '補充を含めて開始', en: 'Release with replenishment' },
  'mfg.wo.replenishSkip': { ja: '補充なしで開始', en: 'Release without replenishment' },
  'mfg.wo.replenishQty': { ja: '補充数', en: 'Replenish qty' },
  'mfg.wo.projected': { ja: '消費後在庫', en: 'Stock after WO' },
  'mfg.wo.reorderPoint': { ja: '発注点', en: 'Reorder point' },
  'mfg.wo.autoReplenish': { ja: '発注点補充の提案', en: 'Reorder-point replenishment' },
  'mfg.wo.autoReplenishHint': { ja: 'オーダー開始時、発注点を下回る部品の補充発注を提案します', en: 'On release, suggest replenishment orders for parts falling below their reorder point' },


  // ── 資材 (Procurement) ─────────────────────────────────────────────
  'app.shizai': { ja: '資材', en: 'Procurement' },
  'app.marketing': { ja: '営業', en: 'Sales' },
  'nav.marketing': { ja: '営業', en: 'Sales' },
  'tab.marketing': { ja: '営業', en: 'Sales' },
  'mfg.nav.shipping': { ja: '出荷管理', en: 'Shipping' },
  'nav.shizai': { ja: '資材', en: 'Procurement' },
  'launcher.desc.shizai': { ja: '発注・仕入先・購買履歴・入荷', en: 'Orders, vendors, history & receiving' },
  'launcher.desc.marketing': { ja: '見積・受注・出荷・売上確定の一元管理', en: 'Quotes, orders, shipping & sales confirmation' },
  'app.parts_request': { ja: '部品受注入力', en: 'Parts Request' },
  'launcher.desc.parts_request': { ja: '必要な部品を資材担当へ依頼', en: 'Ask the buyer for parts you need' },
  'shizai.title': { ja: '資材', en: 'Procurement' },
  'shizai.subtitle': { ja: '発注・購買履歴・入荷を一元管理', en: 'Orders, purchasing & receiving in one place' },
  'shizai.nav.dashboard': { ja: 'ダッシュボード', en: 'Dashboard' },
  'shizai.nav.kanban': { ja: 'かんばんボード', en: 'Kanban' },
  'shizai.nav.requests': { ja: '発注依頼', en: 'Requests' },
  'shizai.nav.approvals': { ja: '承認一覧', en: 'Approvals' },
  'shizai.nav.orders': { ja: '発注一覧', en: 'Orders' },
  'shizai.nav.suppliers': { ja: '仕入先', en: 'Vendors' },
  'shizai.nav.history': { ja: '購買履歴', en: 'History' },
  'shizai.nav.skuGenerator': { ja: '品番採番', en: 'SKU Generator' },
  'shizai.nav.receiving': { ja: '入荷スキャン', en: 'Receiving' },
  'shizai.nav.reorder': { ja: '補充提案', en: 'Reorder' },
  'shizai.nav.invoices': { ja: '請求書照合', en: 'Invoices' },
  'shizai.new': { ja: '新規', en: 'New' },
  'shizai.save': { ja: '保存', en: 'Save' },
  'shizai.saving': { ja: '保存中…', en: 'Saving…' },
  'shizai.cancel': { ja: 'キャンセル', en: 'Cancel' },
  'shizai.close': { ja: '閉じる', en: 'Close' },
  'shizai.search': { ja: '検索', en: 'Search' },
  'shizai.all': { ja: 'すべて', en: 'All' },
  'shizai.byDeptOpen': { ja: '部門別の未処理依頼', en: 'Open requests by department' },
  'shizai.req.department': { ja: '製造部門', en: 'Department' },
  'shizai.req.deptNone': { ja: '部門なし / 未指定', en: 'No department' },
  'shizai.none': { ja: 'なし', en: 'None' },
  'shizai.saved': { ja: '保存しました', en: 'Saved' },
  'shizai.deleted': { ja: '削除しました', en: 'Deleted' },
  'shizai.error': { ja: 'エラーが発生しました', en: 'Something went wrong' },
  'shizai.edit': { ja: '編集', en: 'Edit' },
  'shizai.delete': { ja: '削除', en: 'Delete' },
  'shizai.view': { ja: '表示', en: 'View' },
  // stats
  'shizai.stat.openRequests': { ja: '未処理の依頼', en: 'Open requests' },
  'shizai.stat.inProgress': { ja: '発注中', en: 'In progress' },
  'shizai.stat.overdue': { ja: '納期超過', en: 'Overdue' },
  'shizai.stat.received': { ja: '今月の入荷', en: 'Received (month)' },
  'shizai.stat.draft': { ja: '作成中', en: 'Draft' },
  'shizai.stat.unpaid': { ja: '未払い', en: 'Unpaid' },
  // dashboard sections
  'shizai.dash.openRequests': { ja: '未処理の発注依頼', en: 'Open procurement requests' },
  'shizai.dash.inProgress': { ja: '進行中の発注', en: 'Orders in progress' },
  'shizai.dash.recent': { ja: '最近の入荷', en: 'Recent deliveries' },
  'shizai.dash.noRequests': { ja: '未処理の依頼はありません', en: 'No open requests' },
  'shizai.dash.noOrders': { ja: '進行中の発注はありません', en: 'No orders in progress' },
  'shizai.dash.noRecent': { ja: '入荷履歴はありません', en: 'No deliveries yet' },
  'shizai.dash.todo': { ja: '今日やること', en: 'To do today' },
  'shizai.dash.monthSummary': { ja: '今月のサマリー', en: 'This month' },
  'shizai.dash.byDept': { ja: '部門別 未処理', en: 'Open by department' },
  'shizai.dash.todo.approve': { ja: '承認待ち', en: 'Pending approval' },
  'shizai.dash.todo.approve.hint': { ja: '審査ページで承認・却下', en: 'Approve/reject in the审査 page' },
  'shizai.dash.todo.overdue': { ja: '期限切れ', en: 'Overdue' },
  'shizai.dash.todo.overdue.hint': { ja: '納期を過ぎた発注に対応', en: 'Handle past-due orders' },
  'shizai.dash.todo.partial': { ja: '一部入荷', en: 'Partially received' },
  'shizai.dash.todo.partial.hint': { ja: '残りを検収に登録', en: 'Register remaining receipts' },
  'shizai.dash.todo.invoice': { ja: '請求書照合', en: 'Invoice matching' },
  'shizai.dash.todo.invoice.hint': { ja: '未払いの発注を照合', en: 'Reconcile unpaid orders' },
  'shizai.dash.todo.request': { ja: '未処理依頼', en: 'Open requests' },
  'shizai.dash.todo.request.hint': { ja: 'かんばんに移動して発注化', en: 'Move to Kanban to order' },
  'shizai.dash.action.go': { ja: '対応する', en: 'Go' },
  'shizai.order.placeOrder': { ja: '発注する', en: 'Create order' },
  // request fields
  'shizai.req.no': { ja: '依頼No.', en: 'Request No.' },
  'shizai.req.seibang': { ja: '製番', en: 'Mfg No.' },
  'shizai.req.unitNo': { ja: 'ユニットNo.', en: 'Unit No.' },
  'shizai.req.partNo': { ja: '品番', en: 'Part No.' },
  'shizai.req.drawingNo': { ja: '図番', en: 'Drawing No.' },
  'shizai.req.name': { ja: '品名/形式寸法', en: 'Item name' },
  'shizai.req.material': { ja: '材質', en: 'Material' },
  'shizai.req.maker': { ja: 'メーカー', en: 'Maker' },
  'shizai.req.qty': { ja: '数量', en: 'Qty' },
  'shizai.req.uom': { ja: '単位', en: 'Unit' },
  'shizai.req.neededBy': { ja: '希望納期', en: 'Needed by' },
  'shizai.req.item': { ja: '在庫品目（任意）', en: 'Inventory item (optional)' },
  'shizai.req.priority': { ja: '優先度', en: 'Priority' },
  'shizai.req.notes': { ja: '備考', en: 'Notes' },
  'shizai.req.status': { ja: '状態', en: 'Status' },
  'shizai.req.new': { ja: '発注依頼を作成', en: 'New request' },
  'shizai.req.edit': { ja: '発注依頼を編集', en: 'Edit request' },
  'shizai.req.empty': { ja: '発注依頼がありません', en: 'No requests yet' },
  'shizai.priority.low': { ja: '低', en: 'Low' },
  'shizai.priority.normal': { ja: '通常', en: 'Normal' },
  'shizai.priority.high': { ja: '高', en: 'High' },
  'shizai.reqStatus.open': { ja: '未処理', en: 'Open' },
  'shizai.reqStatus.received': { ja: '入荷済み', en: 'Received' },
  'shizai.reqStatus.partial': { ja: '一部入荷', en: 'Partially received' },
  'shizai.reqStatus.ordered': { ja: '発注済み', en: 'Ordered' },
  'shizai.reqStatus.closed': { ja: '完了', en: 'Closed' },
  // Parts-request source badges (buyer-side view of 部品受注入力 submissions)
  'shizai.req.sourceParts': { ja: '部品依頼', en: 'Parts request' },
  'shizai.req.sourceBuyer': { ja: '内部', en: 'Internal' },
  'shizai.req.orderName': { ja: '受注品名', en: 'Order name' },
  'shizai.req.orderCategory': { ja: '受注分類', en: 'Order category' },
  'shizai.req.attachments': { ja: '添付ファイル', en: 'Attachments' },
  'shizai.req.refUrl': { ja: '参考URL', en: 'Reference URL' },
  'shizai.req.requester': { ja: '依頼者', en: 'Requester' },
  'shizai.req.expand': { ja: '詳細を開く', en: 'Show details' },
  'shizai.req.collapse': { ja: '詳細を閉じる', en: 'Hide details' },
  'shizai.req.filterSource': { ja: 'ソース', en: 'Source' },
  'shizai.req.filterAllSource': { ja: 'すべて', en: 'All' },
  'shizai.req.filterPartsOnly': { ja: '部品依頼のみ', en: 'Parts requests only' },
  'shizai.req.filterBuyerOnly': { ja: '内部のみ', en: 'Internal only' },
  'shizai.reorder.title': { ja: '発注推奨品（発注点未満）', en: 'Reorder suggestions' },
  'shizai.reorder.empty': { ja: '発注点を下回る品目はありません', en: 'No items below their reorder point' },
  'shizai.reorder.item': { ja: '品目', en: 'Item' },
  'shizai.reorder.onHand': { ja: '現在庫', en: 'On hand' },
  'shizai.reorder.reorderPoint': { ja: '発注点', en: 'Reorder pt' },
  'shizai.reorder.suggestQty': { ja: '提案数量', en: 'Order qty' },
  'shizai.reorder.packHint': { ja: '袋数入力', en: 'Enter as packs' },
  'shizai.reorder.supplier': { ja: '仕入先', en: 'Vendor' },
  'shizai.reorder.pending': { ja: '依頼中', en: 'Pending' },
  'shizai.reorder.selectAll': { ja: '全選択', en: 'Select all' },
  'shizai.reorder.clearAll': { ja: '全解除', en: 'Clear all' },
  'shizai.reorder.priority': { ja: '優先度', en: 'Priority' },
  'shizai.reorder.neededBy': { ja: '希望納期', en: 'Needed by' },
  'shizai.reorder.create': { ja: '発注依頼を作成', en: 'Create requests' },
  'shizai.reorder.created': { ja: '発注依頼を作成しました', en: 'Requests created' },
  'shizai.reorder.noneSelected': { ja: '対象を選択してください', en: 'Select at least one item' },
  // order fields
  'shizai.order.no': { ja: '注文No.', en: 'Order No.' },
  'shizai.order.supplier': { ja: '仕入先', en: 'Vendor' },
  'shizai.order.orderDate': { ja: '発注日', en: 'Order date' },
  'shizai.order.dueDate': { ja: '納期', en: 'Due date' },
  'shizai.order.deliveryLocation': { ja: '納入場所', en: 'Delivery location' },
  'shizai.order.taxRate': { ja: '消費税率', en: 'Tax rate' },
  'shizai.order.notes': { ja: '備考', en: 'Notes' },
  'shizai.order.lines': { ja: '明細', en: 'Lines' },
  'shizai.order.addLine': { ja: '明細を追加', en: 'Add line' },
  'shizai.order.subtotal': { ja: '小計', en: 'Subtotal' },
  'shizai.order.tax': { ja: '消費税', en: 'Tax' },
  'shizai.order.total': { ja: '合計', en: 'Total' },
  'shizai.order.unitPrice': { ja: '単価', en: 'Unit price' },
  'shizai.order.amount': { ja: '金額', en: 'Amount' },
  'shizai.order.revision': { ja: '改訂', en: 'Rev.' },
  'shizai.order.received': { ja: '入荷済', en: 'Received' },
  'shizai.order.new': { ja: '新規発注', en: 'New order' },
  'shizai.order.edit': { ja: '発注を編集', en: 'Edit order' },
  'shizai.order.empty': { ja: '発注がありません', en: 'No orders yet' },
  'shizai.order.print': { ja: '帳票印刷', en: 'Print documents' },
  'shizai.order.send': { ja: '発注（送信記録）', en: 'Mark ordered' },
  'shizai.order.receive': { ja: '入荷登録', en: 'Receive' },
  'shizai.order.cancel': { ja: '発注を取消', en: 'Cancel order' },
  'shizai.order.markPaid': { ja: '支払済みにする', en: 'Mark paid' },
  'shizai.order.markUnpaid': { ja: '未払いに戻す', en: 'Mark unpaid' },
  'shizai.order.suggest': { ja: '履歴から提案', en: 'Suggest from history' },
  'shizai.order.suggestNone': { ja: '購買履歴がありません', en: 'No purchase history' },
  'shizai.order.payment': { ja: '支払', en: 'Payment' },
  'shizai.orderStatus.draft': { ja: '作成中', en: 'Draft' },
  'shizai.orderStatus.ordered': { ja: '発注済み', en: 'Ordered' },
  'shizai.orderStatus.partially_received': { ja: '一部入荷', en: 'Partial' },
  'shizai.orderStatus.received': { ja: '入荷完了', en: 'Received' },
  'shizai.orderStatus.cancelled': { ja: '取消', en: 'Cancelled' },
  'shizai.pay.unpaid': { ja: '未払い', en: 'Unpaid' },
  'shizai.pay.paid': { ja: '支払済み', en: 'Paid' },
  'shizai.approval.not_required': { ja: '承認不要', en: 'No approval' },
  'shizai.approval.pending': { ja: '承認待ち', en: 'Pending' },
  'shizai.approval.approved': { ja: '承認済み', en: 'Approved' },
  'shizai.approval.rejected': { ja: '却下', en: 'Rejected' },
  'shizai.approval.approve': { ja: '承認', en: 'Approve' },
  'shizai.approval.reject': { ja: '却下', en: 'Reject' },
  'shizai.approval.rejectPrompt': { ja: '却下理由を入力してください（任意）', en: 'Reason for rejection (optional)' },
  'shizai.approval.needApproval': { ja: '承認が必要です', en: 'Approval required' },
  'shizai.approval.pendingOnly': { ja: '承認待ちのみ', en: 'Pending only' },
  'shizai.approval.settings': { ja: '発注承認の設定', en: 'PO approval settings' },
  'shizai.approval.enable': { ja: '発注承認を有効化', en: 'Require PO approval' },
  'shizai.approval.enableDesc': { ja: 'しきい値以上の発注は送信前に承認が必要になります。', en: 'POs at/above the threshold need approval before they can be sent.' },
  'shizai.approval.threshold': { ja: '承認しきい値（合計金額）', en: 'Approval threshold (total)' },
  'shizai.approval.thresholdHint': { ja: '0 にすると全ての発注が承認対象になります。', en: 'Set to 0 to require approval for all POs.' },
  // send dialog
  'shizai.send.title': { ja: '発注の送信を記録', en: 'Record order sending' },
  'shizai.send.via': { ja: '送信方法', en: 'Sent via' },
  'shizai.send.fax': { ja: 'FAX', en: 'Fax' },
  'shizai.send.mail': { ja: 'メール', en: 'Email' },
  'shizai.send.post': { ja: '郵送', en: 'Postal mail' },
  'shizai.send.toMail': { ja: '送信先メールアドレス', en: 'Recipient email address' },
  'shizai.send.hintMail': { ja: '下の文面をコピーしてメール送信し、送信後にここで記録します', en: 'Copy the draft below, send it, then record it here' },
  'shizai.send.to': { ja: '送信先（FAX番号など）', en: 'Sent to (fax number etc.)' },
  'shizai.send.note': { ja: 'メモ', en: 'Note' },
  'shizai.send.confirm': { ja: '記録する', en: 'Record' },
  'shizai.send.hint': { ja: '帳票を印刷してFAX／郵送した後、ここで記録します', en: 'After printing & faxing/mailing the documents, record it here' },
  // receive dialog / page
  'shizai.receive.title': { ja: '入荷登録', en: 'Receive goods' },
  'shizai.receive.location': { ja: '入荷棚', en: 'Receiving location' },
  'shizai.receive.qtyThisTime': { ja: '今回入荷数', en: 'Receive now' },
  'shizai.receive.remaining': { ja: '発注残', en: 'Remaining' },
  'shizai.receive.confirm': { ja: '入荷を確定', en: 'Confirm receipt' },
  'shizai.receive.done': { ja: '入荷を登録しました', en: 'Receipt recorded' },
  'shizai.receive.scanHint': { ja: '現品票の注文No.バーコードをスキャンしてください', en: 'Scan the 注文No. barcode on the 現品票 tag' },
  'shizai.receive.scanStart': { ja: 'カメラでスキャン', en: 'Scan with camera' },
  'shizai.receive.manual': { ja: '注文No.を手入力', en: 'Enter order No. manually' },
  'shizai.receive.notFound': { ja: '該当する発注が見つかりません', en: 'No matching order found' },
  'shizai.receive.toShelf': { ja: '入荷品は 資材棚 に在庫登録されます', en: 'Received goods are added to inventory at the 資材棚 shelf' },
  // history
  'shizai.history.title': { ja: '購買履歴', en: 'Purchase history' },
  'shizai.history.searchPh': { ja: '品番・品名・仕入先で検索', en: 'Search part, name or vendor' },
  'shizai.history.empty': { ja: '購買履歴がありません', en: 'No purchase history' },

  // ── スキャナー (Barcode Scanner App) ──
  'app.scanner': { ja: 'スキャナー', en: 'Scanner' },
  'app.demo': { ja: 'デモモード', en: 'Demo Mode' },
  'launcher.openInNewTab': { ja: '新しいタブで開く', en: 'Open in new tab' },
  'launcher.desc.scanner': { ja: 'バーコードで入庫・出庫・貸出・棚卸', en: 'Barcode stock in/out, lending & stocktake' },
  'scanner.title': { ja: 'スキャナー', en: 'Scanner' },
  'scanner.subtitle': { ja: 'バーコードで在庫と資産を管理', en: 'Manage stock & assets by barcode' },
  'scanner.back': { ja: 'ホーム', en: 'Home' },
  'scanner.mode.stock_in': { ja: '入庫', en: 'Stock in' },
  'scanner.mode.stock_out': { ja: '出庫', en: 'Stock out' },
  'scanner.mode.stocktake': { ja: '棚卸', en: 'Stocktake' },
  'scanner.mode.lend': { ja: '貸出', en: 'Lend' },
  'scanner.mode.return': { ja: '返却', en: 'Return' },
  'scanner.mode.assign': { ja: '割当', en: 'Assign' },
  'scanner.mode.verify': { ja: '資産棚卸', en: 'IT audit' },
  'scanner.mode.move': { ja: '場所移動', en: 'Move' },
  'scanner.mode.lookup': { ja: '情報表示', en: 'Lookup' },
  'scanner.mode.eng_use': { ja: '使用', en: 'Use' },
  'scanner.mode.eng_return': { ja: '返却', en: 'Return' },
  'scanner.mode.eng_scrap': { ja: '廃棄', en: 'Scrap' },
  'scanner.mode.bihin_stock': { ja: '在庫調整', en: 'Stock adjust' },
  'scanner.section.stock': { ja: '在庫', en: 'Stock' },
  'scanner.section.asset': { ja: '資産', en: 'Asset' },
  'scanner.assignee.label': { ja: '割当先（社員）', en: 'Assignee (employee)' },
  'scanner.assignee.required': { ja: '割当先の社員を選択してください', en: 'Select an assignee' },
  'scanner.location.label': { ja: '移動先の場所', en: 'New location' },
  'scanner.location.placeholder': { ja: '例: 2F IT室', en: 'e.g. 2F Server room' },
  'scanner.location.required': { ja: '移動先を入力してください', en: 'Enter a destination' },
  'scanner.verify.hint': { ja: 'スキャンした資産に監査日時を記録します（在庫状態は変更しません）', en: 'Stamps the verified date/time on the scanned asset (no state change)' },
  'scanner.lookup.hint': { ja: '読み取り専用モード — 資産の詳細と現在の状態を確認できます', en: 'Read-only mode — check asset details & current state' },
  'scanner.assignedTo': { ja: '使用者', en: 'Assigned to' },
  'scanner.locationCurrent': { ja: '現在の場所', en: 'Current location' },
  'scanner.lastVerified': { ja: '最終棚卸', en: 'Last verified' },
  'scanner.itAssetOnly': { ja: 'このモードはIT資産のみサポートしています', en: 'This mode supports IT assets only' },
  'scanner.gate.subtitle': { ja: 'どちらの作業を行いますか？', en: 'What kind of work will you be doing?' },
  'scanner.gate.mfg.title': { ja: '製造管理', en: 'Manufacturing' },
  'scanner.gate.mfg.desc': { ja: '部品・原材料の入出庫、設備の貸出返却', en: 'Stock in/out, equipment lending & returns' },
  'scanner.gate.it.title': { ja: 'IT資産管理', en: 'IT Asset Management' },
  'scanner.gate.it.desc': { ja: 'PCや周辺機器の登録・棚卸・移動', en: 'Assign, audit and relocate IT assets' },
  'scanner.gate.eng.title': { ja: '技術資産管理', en: 'Engineering Assets' },
  'scanner.gate.eng.desc': { ja: '技術資産の使用・返却・廃棄を記録', en: 'Record use, return & scrap of engineering assets' },
  'scanner.gate.bihin.title': { ja: '備品管理', en: 'Office Equipment' },
  'scanner.gate.bihin.desc': { ja: '備品の貸出・返却、消耗品の在庫調整', en: 'Lend/return equipment & adjust consumable stock' },
  'scanner.gate.footer': { ja: '毎回この画面から作業内容を選択します。ヘッダーの切替ボタンでいつでも変更できます。', en: 'Pick a workflow each time you open the scanner. Switch anytime from the header button.' },
  'scanner.deptRequired': { ja: '入庫・出庫・棚卸には部門の選択が必要です（資産モードは不要）', en: 'Stock in/out & stocktake require a department (asset modes do not)' },
  'scanner.scan.start': { ja: 'カメラでスキャン', en: 'Scan with camera' },
  'scanner.scan.stop': { ja: 'スキャン停止', en: 'Stop scanning' },
  'scanner.scan.manual': { ja: 'コードを手入力', en: 'Enter code manually' },
  'scanner.scan.hint': { ja: 'カメラにバーコード／QRをかざすと連続スキャンします', en: 'Point the camera at a barcode/QR to scan continuously' },
  'scanner.scan.notFound': { ja: '該当するコードが見つかりません', en: 'Code not found' },
  'scanner.wrongKind': { ja: 'このモードでは使用できないコードです', en: 'This code cannot be used in this mode' },
  'scanner.cart.title': { ja: 'カート', en: 'Cart' },
  'scanner.cart.empty': { ja: 'スキャンした項目がここに表示されます', en: 'Scanned items appear here' },
  'scanner.cart.commit': { ja: '確定する', en: 'Commit' },
  'scanner.cart.clear': { ja: 'クリア', en: 'Clear' },
  'scanner.cart.qty': { ja: '数量', en: 'Qty' },
  'scanner.cart.counted': { ja: '実棚数', en: 'Counted' },
  'scanner.cart.onHand': { ja: '現在庫', en: 'On hand' },
  'scanner.cart.location': { ja: '保管場所', en: 'Location' },
  'scanner.cart.noLocation': { ja: '指定なし', en: 'Not specified' },
  'scanner.borrower.label': { ja: '貸出先（社員）', en: 'Borrower (employee)' },
  'scanner.borrower.select': { ja: '社員を選択', en: 'Select employee' },
  'scanner.borrower.search': { ja: '氏名・コードで検索', en: 'Search name or code' },
  'scanner.borrower.required': { ja: '貸出先の社員を選択してください', en: 'Select a borrower' },
  'scanner.committed': { ja: '登録しました', en: 'Committed' },
  'scanner.undo': { ja: '元に戻す', en: 'Undo' },
  'scanner.undone': { ja: '取り消しました', en: 'Undone' },
  'scanner.printLabels': { ja: 'ラベル印刷', en: 'Print labels' },
  'scanner.sessions.title': { ja: '最近の操作', en: 'Recent activity' },
  'scanner.sessions.empty': { ja: 'まだ操作はありません', en: 'No activity yet' },
  'scanner.sessions.undone': { ja: '取消済', en: 'Undone' },
  'scanner.lentTo': { ja: '貸出中', en: 'On loan' },
  'scanner.error': { ja: 'エラーが発生しました', en: 'An error occurred' },
  'scanner.itemsUnit': { ja: '件', en: '' },
  'scanner.guide.title': { ja: '使い方ガイド', en: 'Quick guide' },
  'scanner.guide.show': { ja: '表示', en: 'Show' },
  'scanner.guide.hide': { ja: '隠す', en: 'Hide' },
  'scanner.guide.s1': { ja: '部門を選び、上部のモードを選択します（入庫・出庫・貸出・返却・棚卸）。', en: 'Pick a department, then choose a mode at the top (stock in/out, lend, return, stocktake).' },
  'scanner.guide.s2': { ja: 'カメラでバーコード／QRを連続スキャン、または手入力してカートに追加します。', en: 'Continuously scan barcodes/QR with the camera, or type a code to add it to the cart.' },
  'scanner.guide.s3': { ja: 'カートで数量・実棚数を確認し、貸出時は貸出先の社員を選んで「確定する」を押します。', en: 'Review quantities in the cart (pick a borrower for lending), then press Commit.' },
  'scanner.guide.s4': { ja: '確定直後に「元に戻す」を押すと、そのバッチをまとめて取り消せます。', en: 'Right after committing, press Undo to reverse the whole batch at once.' },
  'scanner.guide.s5': { ja: '入庫後は「ラベル印刷」でバーコードラベルを発行できます。', en: 'After stock-in, print barcode labels with the Print labels button.' },

  // ── 申請履歴 (Submissions History) ──
  'hist.title': { ja: '申請履歴', en: 'Submission History' },
  'hist.subtitle': { ja: '送信された申請フォームの履歴を確認できます。複数選択して一括印刷も可能です。', en: 'Browse submitted request forms. Select multiple entries for bulk printing.' },
  'hist.type.all': { ja: 'すべて', en: 'All types' },
  'hist.type.overtime': { ja: '勤務指示書', en: 'Overtime Order' },
  'hist.type.leave': { ja: '休暇届', en: 'Leave Request' },
  'hist.type.leave_transfer': { ja: '振替休暇申請書', en: 'Substitute Leave' },
  'hist.type.work_declaration': { ja: '勤務時間申告書', en: 'Work Hours Declaration' },
  'hist.type.travel_expense': { ja: '出張旅費精算書', en: 'Travel Expense Report' },
  'hist.status.all': { ja: 'すべての状態', en: 'All statuses' },
  'hist.status.awaiting_sign': { ja: '署名待ち', en: 'Awaiting signature' },
  'hist.status.awaiting_check': { ja: '確認待ち', en: 'Awaiting check' },
  'hist.status.awaiting_approve': { ja: '承認待ち', en: 'Awaiting approval' },
  'hist.status.approved': { ja: '承認済み', en: 'Approved' },
  'hist.t.fetchFail': { ja: '申請履歴の取得に失敗しました', en: 'Failed to load submissions' },
  'hist.confirmDelete': { ja: 'この申請を削除しますか？', en: 'Delete this submission?' },
  'hist.t.deleted': { ja: '申請を削除しました', en: 'Submission deleted' },
  'hist.t.deleteFail': { ja: '削除に失敗しました', en: 'Failed to delete' },
  'hist.t.resent': { ja: '通知メールを再送信しました', en: 'Notification email resent' },
  'hist.t.resendFail': { ja: 'メールの再送信に失敗しました', en: 'Failed to resend email' },
  'hist.t.selectForPrint': { ja: '印刷する申請を選択してください', en: 'Select submissions to print' },
  'hist.t.selectForPdf': { ja: 'PDFにする申請を選択してください', en: 'Select submissions to export as PDF' },
  'hist.confirmBulkDelete': { ja: '選択した {n} 件の申請を削除します。よろしいですか？', en: 'Delete the {n} selected submissions?' },
  'hist.t.bulkDeleted': { ja: '{n} 件を削除しました', en: 'Deleted {n} submissions' },
  'hist.t.bulkDeleteFail': { ja: '一括削除に失敗しました', en: 'Bulk delete failed' },
  'hist.t.bulkResent': { ja: '{n} 件のメールを再送信予約しました', en: 'Queued {n} emails for resending' },
  'hist.t.bulkResendFail': { ja: '一括再送信に失敗しました', en: 'Bulk resend failed' },
  'hist.csv.type': { ja: 'フォーム種別', en: 'Form type' },
  'hist.csv.name': { ja: '申請者', en: 'Applicant' },
  'hist.csv.dept': { ja: '所属', en: 'Department' },
  'hist.csv.date': { ja: '申請日', en: 'Form date' },
  'hist.csv.submitted': { ja: '提出日時', en: 'Submitted at' },
  'hist.csv.printed': { ja: '最終印刷日', en: 'Last printed' },
  'hist.csv.data': { ja: 'データ(JSON)', en: 'Data (JSON)' },
  'hist.t.csvDone': { ja: '{n} 件をCSVに出力しました', en: 'Exported {n} to CSV' },
  'hist.t.xlsxDone': { ja: '{n} 件をExcelに出力しました', en: 'Exported {n} to Excel' },
  'hist.t.xlsxFail': { ja: 'Excel 出力に失敗しました', en: 'Excel export failed' },
  'hist.t.markedPrinted': { ja: '{n} 件を印刷済みに設定しました', en: 'Marked {n} as printed' },
  'hist.t.markPrintedFail': { ja: '印刷済み設定に失敗しました', en: 'Failed to mark as printed' },
  'hist.t.printChecked': { ja: '印刷確認済みにしました', en: 'Marked as print-checked' },
  'hist.t.printUnchecked': { ja: '印刷確認を解除しました', en: 'Print check removed' },
  'hist.t.printCheckFail': { ja: '印刷確認の更新に失敗しました', en: 'Failed to update print check' },
  'hist.pc.checkedBy': { ja: '{name} が確認 ({date})', en: 'Checked by {name} ({date})' },
  'hist.pc.markTip': { ja: '印刷確認済みにする', en: 'Mark as print-checked' },
  'hist.pc.approverOnly': { ja: '所属部署の承認担当者のみ変更できます', en: 'Only department approvers can change this' },
  'hist.stageTip': { ja: '現在の段階: {label}', en: 'Current stage: {label}' },
  'hist.action.view': { ja: '詳細を見る', en: 'View details' },
  'hist.action.more': { ja: 'その他の操作', en: 'More actions' },
  'hist.action.pdf': { ja: 'PDFで保存', en: 'Save as PDF' },
  'hist.action.edit': { ja: '編集', en: 'Edit' },
  'hist.action.verify': { ja: '署名・検証・承認', en: 'Sign / verify / approve' },
  'hist.action.resend': { ja: 'メール再送信', en: 'Resend email' },
  'hist.action.delete': { ja: '削除', en: 'Delete' },
  'hist.searchPh': { ja: '申請者名で検索...', en: 'Search by applicant...' },
  'hist.filter.deptPh': { ja: '所属で絞り込み', en: 'Filter by department' },
  'hist.filter.allDepts': { ja: 'すべての所属', en: 'All departments' },
  'hist.filter.monthPh': { ja: '月で絞り込み', en: 'Filter by month' },
  'hist.filter.allMonths': { ja: 'すべての月', en: 'All months' },
  'hist.filter.statusPh': { ja: '承認状態', en: 'Approval status' },
  'hist.monthLabel': { ja: '{y}年{m}月 ({pm}/16-{m}/15)', en: '{y}-{m2} ({pm}/16-{m}/15)' },
  'hist.clear': { ja: 'クリア', en: 'Clear' },
  'hist.clearTip': { ja: 'フィルターをリセット', en: 'Reset filters' },
  'hist.count': { ja: '{a} / {b} 件', en: '{a} / {b}' },
  'hist.view.list': { ja: '一覧', en: 'List' },
  'hist.view.pivot': { ja: 'ピボット', en: 'Pivot' },
  'hist.bulk.selected': { ja: '{n} 件選択中:', en: '{n} selected:' },
  'hist.bulk.print': { ja: '一括印刷', en: 'Print all' },
  'hist.bulk.pdf': { ja: 'PDF出力', en: 'Export PDF' },
  'hist.bulk.resend': { ja: '一括再送信', en: 'Resend all' },
  'hist.bulk.markPrinted': { ja: '印刷済みに設定', en: 'Mark as printed' },
  'hist.bulk.csv': { ja: 'CSV出力', en: 'Export CSV' },
  'hist.bulk.xlsx': { ja: 'Excel出力', en: 'Export Excel' },
  'hist.bulk.delete': { ja: '一括削除', en: 'Delete all' },
  'hist.bulk.clearSel': { ja: '選択を解除', en: 'Clear selection' },
  'hist.loading': { ja: '読み込み中...', en: 'Loading...' },
  'hist.pivot.row': { ja: '行', en: 'Rows' },
  'hist.pivot.col': { ja: '列', en: 'Columns' },
  'hist.pivot.colTypes': { ja: '種類（5フォーム）', en: 'Form types (5)' },
  'hist.pivot.applicant': { ja: '申請者', en: 'Applicant' },
  'hist.pivot.dept': { ja: '所属', en: 'Department' },
  'hist.pivot.month': { ja: '月', en: 'Month' },
  'hist.pivot.cellHint': { ja: 'セルをクリックで一覧に絞り込み', en: 'Click a cell to filter the list' },
  'hist.pivot.pdfBtn': { ja: '月次まとめPDF', en: 'Monthly summary PDF' },
  'hist.pivot.noData': { ja: '対象データがありません', en: 'No matching data' },
  'hist.pivot.total': { ja: '合計', en: 'Total' },
  'hist.pivot.drillTip': { ja: '{row} × {col} ({n}件) を一覧で表示', en: 'Show {row} × {col} ({n}) in the list' },
  'hist.pdf.popupBlocked': { ja: 'ポップアップがブロックされました。許可してください。', en: 'Popup blocked — please allow popups.' },
  'hist.pdf.allPeriods': { ja: '全期間', en: 'All periods' },
  'hist.pdf.cycleLabel': { ja: '{y}年{m}月度（{pm}/16〜{m}/15）', en: '{y}-{m2} cycle ({pm}/16–{m}/15)' },
  'hist.pdf.allTypes': { ja: '全種類', en: 'All types' },
  'hist.pdf.allDepts': { ja: '全部署', en: 'All departments' },
  'hist.pdf.docTitle': { ja: '月次まとめ', en: 'Monthly Summary' },
  'hist.pdf.heading': { ja: '月次まとめ（{row}別 × 申請種類）', en: 'Monthly Summary ({row} × form type)' },
  'hist.pdf.cycle': { ja: '対象締め', en: 'Cycle' },
  'hist.pdf.type': { ja: '種類', en: 'Type' },
  'hist.pdf.dept': { ja: '所属', en: 'Department' },
  'hist.pdf.total': { ja: '合計件数', en: 'Total' },
  'hist.pdf.generated': { ja: '出力日時', en: 'Generated' },
  'hist.pdf.countSuffix': { ja: '件', en: '' },
  'hist.empty': { ja: '申請履歴がありません', en: 'No submissions yet' },
  'hist.emptyHint': { ja: 'フォームを送信するとここに表示されます。', en: 'Submitted forms will appear here.' },
  'hist.th.date': { ja: '申請日', en: 'Date' },
  'hist.th.type': { ja: '種類', en: 'Type' },
  'hist.th.name': { ja: '申請者', en: 'Applicant' },
  'hist.th.dept': { ja: '所属', en: 'Department' },
  'hist.th.printed': { ja: '最終印刷日', en: 'Last printed' },
  'hist.th.printCheck': { ja: '印刷確認', en: 'Print check' },
  'hist.th.actions': { ja: '操作', en: 'Actions' },
  'hist.submittedTip': { ja: '提出: {date}', en: 'Submitted: {date}' },
  'hist.notPrinted': { ja: '未印刷', en: 'Not printed' },
  'hist.unset': { ja: '(未設定)', en: '(Unset)' },
  'hist.noDate': { ja: '(日付なし)', en: '(No date)' },
  'hist.employeeEditTip': { ja: '{name} の社員情報を編集', en: 'Edit employee record for {name}' },

  // ── 開発案件（A1b / A1c）──
  'dev.badge.overdue': { ja: '期限超過', en: 'Past due' },
  'dev.badge.overdueDays': { ja: '期限超過 {n}日', en: '{n} days past due' },
  'dev.badge.needsPartsSetup': { ja: '要確認: 部品・製作台数', en: 'Check: parts & build qty' },
  'dev.tile.overdue': { ja: '期限超過', en: 'Overdue' },
  'dev.tile.overdueHint': { ja: '目標完了日を過ぎた案件', en: 'Cases past their target date' },
  'dev.gate.partsRequired': {
    ja: '製作台数と必要部品が登録されている',
    en: 'Build quantity and required parts are registered',
  },
  'dev.nas.adminNotice': {
    ja: '共有フォルダーの設定に問題があります（管理者向け）',
    en: 'Shared folder configuration problem (for administrators)',
  },
  'dev.nas.dismiss': { ja: '了解（今後表示しない）', en: 'Got it (hide from now on)' },

  // ── 出庫（A2）/ ロット管理（A3）──
  'mfg.action.issue': { ja: '出庫', en: 'Issue' },
  'mfg.issue.title': { ja: '出庫（使用・払出）', en: 'Issue stock (use / hand out)' },
  'mfg.issue.qty': { ja: '出庫数', en: 'Quantity' },
  'mfg.issue.reason': { ja: '理由', en: 'Reason' },
  'mfg.issue.reason.production': { ja: '製造使用', en: 'Used in production' },
  'mfg.issue.reason.prototype': { ja: '試作使用', en: 'Used for a prototype' },
  'mfg.issue.reason.scrap': { ja: '不良廃棄', en: 'Scrapped (defective)' },
  'mfg.issue.reason.return': { ja: '返品', en: 'Returned' },
  'mfg.issue.reason.other': { ja: 'その他', en: 'Other' },
  'mfg.issue.refType': { ja: '参照先', en: 'Booked against' },
  'mfg.issue.ref': { ja: '対象', en: 'Target' },
  'mfg.issue.refPick': { ja: '選択してください', en: 'Please select' },
  'mfg.issue.location': { ja: '出庫元ロケーション', en: 'Source location' },
  'mfg.issue.anyLocation': { ja: '指定なし（古いロットから）', en: 'Any (oldest lot first)' },
  'mfg.issue.note': { ja: 'メモ', en: 'Note' },
  'mfg.issue.onHand': { ja: '在庫', en: 'On hand' },
  'mfg.issue.submit': { ja: '出庫する', en: 'Issue' },
  'mfg.issue.needQty': { ja: '出庫数を入力してください', en: 'Enter a quantity' },
  'mfg.issue.needRef': { ja: '参照先を選択してください', en: 'Select what this is for' },
  'mfg.issue.pickItem': { ja: '品目を選択', en: 'Select an item' },
  'mfg.issue.done': {
    ja: '出庫しました（{qty}{uom} / 残 {onHand}）',
    en: 'Issued {qty}{uom} — {onHand} left',
  },
  'mfg.item.lotTrackedHint': {
    ja: 'ロット番号で追跡する品目だけ ON にします（新規は OFF）',
    en: 'Turn on only for items you track by lot number (off for new items)',
  },
  // ── B2 · 統合登録フォームの共通ブロック（UNIFIED_REGISTRATION_SPEC 2.1 / 2.6）──
  'reg.masterSearch': { ja: '品目マスター検索', en: 'Search the item master' },
  'reg.masterSearch.ph': { ja: '名称・品番・型式で探す（任意）', en: 'Search by name, number or model (optional)' },
  'reg.masterSearch.hint': { ja: '見つからなければそのまま下に入力してください（新規として登録されます）', en: "If you can't find it, just fill in the fields below (saved as a new record)" },
  'reg.searching': { ja: '検索中…', en: 'Searching…' },
  'reg.name': { ja: '名称', en: 'Name' },
  'reg.name.ph': { ja: '例: 油圧プレス機 30t', en: 'e.g. Hydraulic press 30t' },
  'reg.number': { ja: '番号（資産番号）', en: 'Number (asset no.)' },
  'reg.number.auto': { ja: '保存時に自動発番', en: 'Issued automatically on save' },
  'reg.number.next': { ja: '次: {no}', en: 'Next: {no}' },
  'reg.number.sharedHint': { ja: 'IT資産・備品と共通の番号空間（EQP）です', en: 'Shared number space with IT assets and fixtures (EQP)' },
  'reg.number.duplicate': { ja: 'この番号は「{owner}」で使われています', en: 'This number is already used by “{owner}”' },
  'reg.category': { ja: 'カテゴリ', en: 'Category' },
  'reg.category.ph': { ja: '例: プレス機', en: 'e.g. Press machine' },
  'reg.kind': { ja: '種別', en: 'Type' },
  'reg.maker': { ja: 'メーカー', en: 'Maker' },
  'reg.maker.ph': { ja: '例: エスペック', en: 'e.g. Espec' },
  'reg.model': { ja: '型式', en: 'Model' },
  'reg.makerPn': { ja: 'メーカー品番', en: 'Maker part no.' },
  'reg.serial': { ja: '製造番号', en: 'Serial no.' },
  'reg.serial.ph': { ja: '例: 2026-00871', en: 'e.g. 2026-00871' },
  'reg.location': { ja: '設置場所', en: 'Location' },
  'reg.location.ph': { ja: '場所マスタから選択…', en: 'Pick from the location master…' },
  'reg.location.search': { ja: '場所を検索（例: 技術室）', en: 'Search locations (e.g. Engineering room)' },
  'reg.location.showAll': { ja: 'すべての部門の場所を表示', en: 'Show locations of every department' },
  'reg.location.empty': { ja: '一致する場所がありません', en: 'No location matches' },
  'reg.location.unregistered': { ja: '未登録の場所: {text}', en: 'Unregistered location: {text}' },
  'reg.location.legacyNote': { ja: 'この場所はマスタにありません。保存前に選び直すと一覧で揃います', en: 'This location is not in the master. Pick one before saving to keep lists consistent' },
  'reg.location.add': { ja: '「{name}」を場所マスタに追加', en: 'Add “{name}” to the location master' },
  'reg.department': { ja: '部門', en: 'Department' },
  'reg.unassigned': { ja: '（未割当）', en: '(unassigned)' },
  'reg.status': { ja: '状態', en: 'Status' },
  'reg.supplier': { ja: '仕入先（注文先）', en: 'Supplier (order from)' },
  'reg.supplier.ph': { ja: '仕入先マスターから選択…', en: 'Pick from the supplier master…' },
  'reg.supplier.free': { ja: 'マスター未登録の店はここに入力（例: モノタロウ）', en: 'Type a shop that is not in the master (e.g. MonotaRO)' },
  'reg.supplier.unregistered': { ja: '未登録の仕入先: {name}', en: 'Unregistered supplier: {name}' },
  'reg.supplier.add': { ja: '＋ 新規仕入先を追加', en: '+ Add a new supplier' },
  'reg.supplier.newPh': { ja: '新しい仕入先名', en: 'New supplier name' },
  'reg.orderUrl': { ja: '注文URL', en: 'Order URL' },
  'reg.owner': { ja: '使用者・管理者', en: 'User / keeper' },
  'reg.acquiredOn': { ja: '取得日', en: 'Acquired date' },
  'reg.price': { ja: '取得価格（円）', en: 'Price (JPY)' },
  'reg.price.ph': { ja: '未入力のままでも登録できます', en: 'You can leave this empty' },
  'reg.notes': { ja: '備考', en: 'Notes' },
  'reg.none': { ja: '（なし）', en: '(none)' },
  'reg.notSet': { ja: '（未設定）', en: '(not set)' },
  'reg.add': { ja: '追加', en: 'Add' },
  'reg.adding': { ja: '追加中…', en: 'Adding…' },
  'reg.stop': { ja: 'やめる', en: 'Cancel' },
  'reg.filterByName': { ja: '名前で絞り込み', en: 'Filter by name' },
  'reg.required.title': { ja: '要入力（このままでも保存できます）', en: 'Needs input (you can still save)' },
  'reg.insp.title': { ja: '点検・校正', en: 'Inspection & calibration' },
  'reg.insp.interval': { ja: '点検間隔（月）', en: 'Inspection interval (months)' },
  'reg.insp.last': { ja: '前回点検日', en: 'Last inspection' },
  'reg.insp.next': { ja: '次回点検日', en: 'Next inspection' },
  'reg.insp.owner': { ja: '点検担当者', en: 'Inspection owner' },
  'reg.insp.overdue': { ja: '点検期限超過（{due}）', en: 'Inspection overdue ({due})' },
  'reg.calib.required': { ja: '校正が必要な計測器', en: 'Instrument that needs calibration' },
  'reg.calib.interval': { ja: '校正間隔（月）', en: 'Calibration interval (months)' },
  'reg.calib.last': { ja: '前回校正日', en: 'Last calibration' },
  'reg.calib.next': { ja: '次回校正日', en: 'Next calibration' },
  'reg.calib.owner': { ja: '校正担当者', en: 'Calibration owner' },
  'reg.calib.overdue': { ja: '校正期限超過（{due}）', en: 'Calibration overdue ({due})' },
  'reg.insp.nextHint': { ja: '未入力なら「前回 + 間隔」で計算します', en: 'Left empty, it is calculated as last + interval' },
  'reg.project': { ja: '由来プロジェクト', en: 'Source project' },
  'reg.project.hint': { ja: 'このプロジェクトの成果物を設備として昇格させます', en: 'Promote this project’s output into the equipment register' },
  'reg.project.archived': { ja: '{name}（一覧外・アーカイブ済み）', en: '{name} (not listed · archived)' },
  'reg.intervalPh': { ja: '例: 12', en: 'e.g. 12' },
  'mfg.eq.status.rented': { ja: '貸出中', en: 'On loan' },
  'mfg.eq.status.on_order': { ja: '発注予定', en: 'To be ordered' },
  'reg.number.keep': { ja: '番号は変わりません', en: 'The number does not change' },
  'reg.number.shared': { ja: '共通採番（{prefix}）', en: 'Shared series ({prefix})' },
  'reg.number.fromRule': { ja: '品番ルールから選ぶ', en: 'Pick a numbering rule' },
  'reg.number.chooseRule': { ja: 'ルールを選ぶ', en: 'Choose a rule' },
  'reg.number.changeRule': { ja: 'ルールを選び直す', en: 'Change the rule' },
  'reg.number.onSaveByRule': { ja: '保存時にルールで発番します', en: 'Issued from the rule when you save' },
  'reg.number.rule': { ja: 'ルール: {rule}', en: 'Rule: {rule}' },
  'reg.number.techsHint': { ja: 'ここで決まる品番が、そのまま TECHS の品番になります（別番号は作りません）', en: 'This number is the one used in TECHS — no separate web-only code' },
  'reg.attach': { ja: '添付ファイル', en: 'Attachments' },
  'reg.attach.add': { ja: 'ファイルを追加', en: 'Add a file' },
  'reg.attach.uploading': { ja: 'アップロード中…', en: 'Uploading…' },
  'reg.attach.limit': { ja: 'PNG/JPG/GIF/WEBP/HEIC/PDF・25MBまで', en: 'PNG/JPG/GIF/WEBP/HEIC/PDF · up to 25MB' },
  'reg.attach.filled': { ja: '入力あり', en: 'filled in' },
  'reg.attach.failed': { ja: 'ファイルの保存に失敗しました', en: 'Could not save the file' },
  'reg.attach.remove': { ja: 'この添付を外す', en: 'Remove this attachment' },
  'reg.reqHistory': { ja: '発注履歴（部品受注入力）', en: 'Order history (parts requests)' },
  'reg.onLoanTo': { ja: '貸出中: {name}（返却予定 {due}）', en: 'On loan to {name} (due {due})' },
  'mfg.common.department': { ja: '部門', en: 'Department' },
};
